<template>
  <div v-if="!isMobile()" class="msorderwrapper">
    <!-- <head> -->
    <title>Dr Order Template</title>
    <div class="order-wrapper col-sm-12 col-lg-12">
      <div class="container">
        <div class="col-sm-12 col-lg-12 opclosesec">
          <span v-if="patient" id="closeOrdermod"
            >Order For:
            <b
              >{{ patient.first_name + " " + patient.lastname }} ({{
                patient.date_of_birth
              }})</b
            ></span
          >
          <span v-else-if="pendingordData != ''">
            {{ pendingordData.firstName }}
          </span>
          <h4></h4>
        </div>
        <!--Add Patiets Form-->
        <div class="providerformsec col-sm-12 col-md-12 col-lg-12">
          <form id="providform">
            <p id="npidlbl">NPID<span id="npispan"></span></p>
            <h3>Add Provider Form</h3>
            <div class="provformrow">
              <div class="fnamesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="fnamefield" placeholder="* First Name" value="" />
              </div>
              <div class="lnamesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="lnamefield" placeholder="* Last Name" value="" />
              </div>
            </div>
            <div class="provformrow">
              <div class="addronesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="addr1field" placeholder="* Address" value="" />
              </div>
              <div class="addrtwosec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="addr2field" placeholder="* Address 2" value="" />
              </div>
            </div>
            <div class="provformrow">
              <div class="citysec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="cityfield" placeholder="* City" value="" />
              </div>
              <div class="statesec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="statefield" placeholder="* State" value="" />
              </div>
            </div>
            <div class="provformrow" style="padding: 0px 85px">
              <div class="zipsec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="zipfield" placeholder="* Zip" value="" />
              </div>
              <div class="telsec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="telfield" placeholder="* Tel" value="" />
              </div>
              <div class="faxsec col-sm-12 col-md-4 col-lg-4">
                <input type="text" id="faxfield" placeholder="* Fax" value="" />
              </div>
            </div>
            <div class="provformrow">
              <div class="savebnt col-sm-12 col-md-2 col-lg-2">
                <input type="button" id="savebtnel" value="Save and Continue" />
              </div>
              <div class="closebnt col-sm-12 col-md-2 col-lg-2">
                <input type="button" id="closebtnel" value="Close" />
              </div>
            </div>
          </form>
        </div>
        <!--end Paitent Form-->
        <form :id="'orderform' + patient.patient_id" @submit.prevent="saveNewOrder()">
          <div class="firstrow col-sm-12">
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="orderdate" role="text">Order Date <span class="required">*</span></label>
              <input type="date" required id="orderdate" class="datefield" name="date" v-model="orderFormDate" />
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="orderdate" role="text">Order Time <span class="required">*</span></label><br />
              <input type="time" required id="ordertime" class="timefield" name="time" v-model="orderFormTime" />
            </div>
            <div class="col-sm-12 col-md-3 col-lg-3">
              <label for="ordertype" role="text">Order Type <span class="required">*</span></label><br />
              <select
                required
                id="ordertype"
                class="ordertype"
                name="ordertype"
                v-model="orderType"
                disabled
              >
                <!-- <option selected="select" value="">Select Order Type</option> -->
                <option value="Physicians Order">Physicians Order</option>
                <option value="Nurses Order">Nurses Order</option>
                <option value="Verbal Order">Verbal Order</option>
              </select>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="abndelivered" role="text"> ABN Delivered?</label>
              <select required id="abntopatient" class="abntopatient" name="abn">
                <option selected value="0">N/A</option>
                <option value="1">Don't Know</option>
                <option value="2">Let's Try</option>
              </select>
            </div>
            <div class="col-sm-12 col-md-2 col-lg-2">
              <label for="phyAgentphy" role="text"> Order Read Back To Physican</label>
              <select required name="phyAgent" id="phyAgentphy" class="phyAgentphy">
                <option selected value="NA">N/A</option>
                <option value="No">No</option>
                <option value="Yes">Yes</option>
              </select>
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 secondrow">
            <!--Verify Account UI Modal Overlay-->
            <div v-if="isAccountVerified == true" class="account-status">
                      <span class="account-text"><b>Account Verified</b></span>
                      <span
												class="icon-immediate"
												style="color: #28a745; margin-left: 0.3rem;"
												title="Account Verified"
											>
												✔
											</span>
                    </div>
                    <div v-else-if="isAccountVerified ==false && showAccountStatTag ==true" class="account-status">
                      <span class="account-text"><b>Account Not Verified</b></span>
                      <span
												class="icon-immediate"
												style="color: #ccc; margin-left: 0.3rem;"
												title="Account Not Verified"
											>
                      ✘
											</span>
                    </div>
                    <div v-if="isAccountVerified==false && showAccountStatTag==true" class="modal-overlay account-modal">
                        <div class="modal-content">
                            <div class="mod-title">Account Not Verified - Send Account Request To Provider</div>
                                <div class="mod-panel">
                                     <span><img :src="'/keyon/images/patient_placeholder.svg'" width="60" height="60"/></span>
                                     <span class="provider-info">{{npiSearch}} {{npinumber}}</span>
                                     <p class="account-error-text">{{accounterrorText}}</p>
                                     <div class="action-btn-container">
                                        <div class="accntverified-section-email" style="width:100%;margin:10px;">
                                            <span class="vaccnt-asterik">*</span><span class="accnt-email"><input type="text" v-model="accntRequestEmail" placeholder="Valid Email Address..."
                                            class="vaccnt-textiput" /></span>
                                        </div>
                                          <button @click="sendAccountRequest(npiSearch,accntRequestEmail,npinumber)" class="action-button-sendrequest" :disabled="isacntRequestBtnDisabled==true" >Send Account Request</button>
                                          <button @click="cancelAccountRequest()" class="action-button-cancelrequest">Cancel Account Request</button>
                                     </div>
                                </div>
                        </div>
                    </div>
            <!--end Verify ccount UI Modal Overlay-->
            <div class="col-sm-12 col-md-4 col-lg-4">
              <label for="primphysician" role="text">Primary Physican <span class="required">*</span></label><br />
              <input
                name="primphysician"
                type="text"
                required
                placeholder=""
                id="primphysician"
                style="z-index: 9000; position: relative"
                class="primphyfield"
                v-model="npiSearch"
                @keyup.prevent="showResults"
                @focus="isPrimaryPhysicianFocused = true"
                
              />
              <div v-if="searchedNpis" id="npinamesearch" class="npinamemodal">
                <div
                  v-for="(npi, index) in searchedNpis"
                  class="additionalnameli"
                  :key="index + 'npi' + npi.npinumber"
                  @click="selectNpi(npi)"
                >
                  {{ npi.name }}
                </div>
              </div>
              <template v-if="isPrimaryPhysicianFocused && npiSearch === '' && !searchedNpis">
                <!--<div class="npinamemodal">Linked Providers</div>
                <div id="npinamesearch" class="npinamemodal">
                  <div
                    v-for="(prov, index) in savedProviders"
                    class="additionalnameli"
                    :key="index + 'npi' + prov.npinumber"
                    @click="selectProv(prov)"
                  >
                    {{ prov.firstname + " " + prov.lastname }}
                  </div>  
                  Adding the Local Account Providers here KW 4/27/6-->
                  
              <!--- </div>-->
              </template>
              <select v-if="ifNurseAccount || ifAdministrator" v-model="loadedProvider" @change="fillProviderInfo(loadedProvider)" :class="'pastProvdisplay-' + (this.pastProvloaded ? 'true' : 'false')">
                  <option v-for="(prov, index) in pastProvar" :key="prov.id ?? index" :value="prov">
                    {{ prov.firstname ?? prov.first_name ?? prov.name }} {{ prov.lastname }}
                  </option>
                </select>
              <div class="addimgprovider">
                <img
                  src="https://cdn0.iconfinder.com/data/icons/users-android-l-lollipop-icon-pack/24/add_user-512.png"
                  alt="Add Provider Image"
                  title="Add Provider"
                  width="40"
                  height="40"
                />
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <label for="secphysician" role="text"> Taxonomy</label><br />
              <input name="taxonomy" type="text" id="taxonomy" class="taxonomy" />
            </div>
            <div class="col-sm-12 col-md-4 col-lg-4">
              <label for="email" role="text">E-mail <span class="required">*</span></label><br />
              <input
                name="email"
                type="email"
                id="email"
                class="email"
                v-model="npiEmail"
                required
                autocomplete="email"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 thirdrow gvspace">
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="npinumber" role="text">NPI Number <span class="required">*</span></label><br />
              <input
                name="npinumber"
                type="text"
                required
                id="npinumber"
                class="npifield"
                v-model="npi"
              />
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="physaddress" role="text">Address <span class="required">*</span></label><br />
              <input
                name="address"
                type="text"
                required
                id="physaddress"
                class="physaddressclass"
                v-model="npiAddress"
              />
              <div
                v-if="searchedAddresses"
                id="npiadditionaladdr"
                class="npiadditionaladdr"
              >
                <div
                  v-for="(addr, index) in searchedAddresses"
                  @click="selectAddr(addr)"
                  class="additonaladdrli"
                  :key="index"
                >
                  {{ addr.address }}
                </div>
              </div>
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="orderphonenumber" role="text">Order Phone Number</label><br />
              <input
                name="orderphone"
                type="tel"
                id="orderphonenumber"
                class="orderphoneclass"
                v-model="npiPhone"
              />
            </div>
            <div class="col-sm-12 col-md-4 col-lg-3">
              <label for="orderfaxnumber" role="text">Order Fax Number</label><br />
              <input
                name="orderfax"
                type="tel"
                id="orderfaxnumber"
                class="orderfaxclass"
                v-model="npiFax"
              />
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12 forthfrow">
            <div class="col-sm-12 col-md-6 col-lg-6 orderaction">
              <label>
                <input
                  type="checkbox"
                  id="sendtophysician"
                  name="sendtophysician"
                  value="Send To Physician"
                  v-model="sendtophys"
                />Send To Physicians</label
              >
              <label>
                <input
                  type="checkbox"
                  name="woundcareorder"
                  id="woundcare"
                  value="Wound Care Order"
                  v-model="woundcare"
                />Wound Care Order</label
              ><br />
              <!-- <label>
                <input type="checkbox" id="verbalorder" name="verbalorder" value="Verbal Order"
                  v-model="verbalorder" />Verbal Order</label>
              <input type="date" name="verbaldate" class="verbdatefield" />
              <input type="time" name="verbaltime" class="verbtimefield" /> -->
              <!--<div class="showverober col-sm-12 col-md-12 col-lg-12">
                                <input type="date" name="verbaldate" class="verbdatefield"/>
                                <input type="time" name="timefield" class="timefield"/>
                            </div>-->
            </div>
          </div>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="preloader" id="preloader" style="display: none">
              <div class="container">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  style="margin: auto; display: block"
                  width="200px"
                  height="200px"
                  viewBox="0 0 100 100"
                  preserveAspectRatio="xMidYMid"
                >
                  <g transform="translate(16.666666666666668 50)">
                    <circle cx="0" cy="0" r="6" fill="#85a2b6">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.4s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(33.333333333333336 50)">
                    <circle cx="0" cy="0" r="6" fill="#bbcedd">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.3s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(50 50)">
                    <circle cx="0" cy="0" r="6" fill="#dce4eb">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.2s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(66.66666666666667 50)">
                    <circle cx="0" cy="0" r="6" fill="#fdfdfd">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="-0.1s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                  <g transform="translate(83.33333333333333 50)">
                    <circle cx="0" cy="0" r="6" fill="#85a2b6">
                      <animateTransform
                        attributeName="transform"
                        type="scale"
                        begin="0s"
                        calcMode="spline"
                        keySplines="0.3 0 0.7 1;0.3 0 0.7 1"
                        values="0;1;0"
                        keyTimes="0;0.5;1"
                        dur="1s"
                        repeatCount="indefinite"
                      ></animateTransform>
                    </circle>
                  </g>
                </svg>
              </div>
            </div>
            <div class="tabs col-sm-12 col-md-12 col-lg-12">
              <div
                class="medicationtab"
                :class="activeTab == 1 ? 'active' : ''"
                :style="{ display: 'block' }"
              >
                <a id="medicationbtn" title="Medications Tab" @click="activeTab = 1"
                  >Medications</a
                >
              </div>
              <!-- <div
                class="diagnosistab"
                :class="activeTab == 2 ? 'active' : ''"
                :style="{ display: 'block' }"
              >
                <a
                  href="#diagnosistab"
                  id="diagnosisbtn"
                  title="Diagnosis Tab"
                  @click="activeTab = 2"
                  >Diagnosis</a
                >
              </div> -->
              <div
                class="proctab"
                :class="activeTab == 3 ? 'active' : ''"
                :style="{ display: 'block' }"
              >
                <a id="procbtn" title="Procedure Tab" @click="activeTab = 3">Procedure</a>
              </div>
              <div class="ordescriptab" :class="activeTab == 0 ? 'active' : ''">
                <a id="ordescripbtn" title="Order Description" @click="activeTab = 0"
                  >Order Description</a
                >
              </div>
            </div>
            <!--<label for="ordertextarea" class="orderlbl">Order Descripton</label><br/>-->
            <div
              id="ordercanvas"
              :style="[activeTab == 0 ? { display: 'block' } : { display: 'none' }]"
            >
              <!-- <editor v-model="message" api-key="wtyerkxnsy7pxhf40g1mq9tjlifsy2ygztyau951df686zv9" :init="{
                plugins: [
                  'advlist',
                  'autolink',
                  'lists',
                  'link',
                  'image',
                  'charmap',
                  'preview',
                  'anchor',
                  'searchreplace',
                  'visualblocks',
                  'fullscreen',
                  'insertdatetime',
                  'media',
                  'table',
                  'help',
                  'wordcount',
                ],
                toolbar:
                  'undo redo | casechange blocks | bold italic backcolor | ' +
                  'alignleft aligncenter alignright alignjustify | ' +
                  'bullist numlist checklist outdent indent | removeformat | code table help',
              }" /> -->
              <EditorComponent v-model="message" editorStyle="height: 300px">
                <template #toolbar>
                  <span class="ql-formats">
                    <button class="ql-bold"></button>
                    <button class="ql-italic"></button>
                    <button class="ql-underline"></button>
                  </span>
                </template>
              </EditorComponent>
              <br />
              <!--<div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
                                <input type="button" value="Cancel" id="cancelbtn" class="cancelbtn"/>
                                <input type="button" value="Save & Close" id="ordersavebtn" class="orderbtn"/>
                            </div>-->
            </div>
            <div
              id="medicationcanvas"
              v-show="activeTab == 1"
            >
              <div class="medbtn_nav">
                <a
                  title="Add Transaction"
                  class="transbuttons active"
                  id="addtransbtn"
                  @click="showAddMed"
                  >Add Medication</a
                >
                <!-- <a
                  href="#Edittransaction"
                  class="transbuttons"
                  title="Edit Transaction"
                  id="edittransbtn"
                  >Edit Transaction</a
                >
                <a
                  href="#Deletetransaction"
                  class="transbuttons"
                  title="Delete Transaction"
                  id="delettransbtn"
                  >Delete Transaction</a
                >
                <a
                  href="#Viewmedications"
                  class="transbuttons"
                  title="Veiw Medications"
                  id="viewcurrentmedsbtn"
                  >View Current Medications</a
                > -->
              </div>
              <div class="divider"><span>New/Edited Medications</span></div>
              <div class="order-grid new-or-edit-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop">
                  <!--Start Colum-->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
                    <span id="col0" class="coltext">Medication</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col1" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col2" class="coltext">Quantity</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col3" class="coltext">Frequency</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Duration</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col5" class="coltext">Start</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col6" class="coltext">Route</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Instructions</span>
                  </div>
                </div>
                <template v-if="newMeds.length != 0">
                  <div
                    v-for="(med, index) in newMeds"
                    :key="'newMed' + index"
                    class="columnrow"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
                      <span id="row" class="coltext">{{ med.medName }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{
                        `${med.diagCode} - ${med.diagDescription}`
                      }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.quantity }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.frequency }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.duration }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.startDate }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.route }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.instructions }}</span>
                    </div>
                  </div>
                </template>
              </div>

              <div class="divider"><span>Previously Ordered Medications</span></div>
              <div
                class="mediationmodal col-sm-12 col-md-12 col-lg-12"
                :id="'mediationmodal' + patient.patient_id"
              >
                <div class="modaltop">
                  <section class="patienttopinfosec col-sm-12 col-md-6 col-lg-6">
                    <div id="patientname">
                      <p id="pname">{{ patient.first_name + " " + patient.lastname }}</p>
                    </div>
                    <div class="allergysec">
                      <span class="allergytext"
                        >Allergies: <span>{{ manualAllergies.toString() }}</span> </span
                      ><br />
                      <p></p>
                    </div>
                  </section>
                  <section class="patientsecondinfosec col-sm-12 col-md-6 col-lg-6">
                    <div id="patientbday">
                      <p id="pday">{{ patient.date_of_birth }}</p>
                    </div>
                    <div class="attendphysician">
                      <!-- <span>Attending Physician</span><br /> -->
                      <!-- <p>Dr. Joseph Mulvehill</p> -->
                    </div>
                  </section>
                </div>
                <form :id="'dosesform' + patient.patient_id" @submit.prevent="addNewMed" class="new-med-form">
                  <div class="order-med-tabs">
                    <button
                      type="button"
                      class="order-med-tab-btn"
                      :class="{ active: orderMedActiveTab === 'medInfo' }"
                      @click="orderMedActiveTab = 'medInfo'"
                    >
                      <div class="order-med-tab-label">Medication Information</div>
                      <div class="order-med-tab-required"><em>required</em></div>
                    </button>
                    <button
                      type="button"
                      class="order-med-tab-btn"
                      :class="{ active: orderMedActiveTab === 'pharmacyInfo' }"
                      @click="orderMedActiveTab = 'pharmacyInfo'"
                    >
                      <div class="order-med-tab-label">Pharmacy Information</div>
                      <div class="order-med-tab-required"><em>required</em></div>
                    </button>
                  </div>
                  <div v-show="orderMedActiveTab === 'medInfo'">
                  <h3 class="section-title">Medication Information</h3>
                  <div class="form-group autocomplete">
                    <label>
                      Medication Name <span class="required">*</span>
                    </label>
                    <input
                      type="text"
                      v-model="medFormData.medicationName"
                      placeholder="Medication Name"
                      required
                      aria-required="true"
                      class="autocomplete-input"
                      @focus="showMedSuggestions = medSearchResults.length > 0"
                      @input="debouncedMedFetch()"
                    />
                    <ul v-if="showMedSuggestions" class="suggestions-list">
                      <li
                        v-for="(item, index) in medSearchResults"
                        :key="item.selectedPackaging?.package_ndc || `item-${index}`"
                        class="suggestion-item"
                        @mousedown.prevent="selectMedResult(item)"
                      >
                        <div class="suggestion-header">
                          <strong>
                            {{ medSearchMode === 'brand' && item.brand_name
                              ? item.brand_name
                              : item.generic_name
                            }}
                          </strong>
                          <span class="suggestion-ingredients">
                            ({{ formatMedIngredients(item.active_ingredients) }})
                          </span>
                      </div>
                        <div class="suggestion-ndc">
                          {{ item.selectedPackaging?.package_ndc || 'N/A' }}
                    </div>
                      </li>
                    </ul>
                  </div>

                  <!-- Dosage + Frequency row -->
                  <div class="form-row">
                    <div class="form-group dosage-group">
                      <label>
                        Dosage <span class="required">*</span>
                      </label>
                      <div class="dosage-row">
                    <input
                          type="number"
                          v-model="medFormData.dosage"
                          placeholder="Dosage"
                          class="dosage-input"
                          required
                          aria-required="true"
                          min="0"
                        />
                      </div>
                    </div>
                    <div class="form-group">
                      <label>Dosage Form</label>
                        <select
                          v-model="medFormData.unitType"
                          class="dosage-select"
                        >
                          <option :value="''">Select Dosage Form</option>
                          <option 
                            v-for="option in dosageOptions"
                            :key="option"
                            :value="option"
                          >
                            {{ option }}
                          </option>
                        </select>
                    </div>
                    <div class="form-group">
                      <label>
                        Frequency <span class="required">*</span>
                      </label>
                      <select
                        v-model="medFormData.frequency"
                        required
                        aria-required="true"
                        @change="handleFrequencyChange"
                        style="width:90%;"
                      >
                        <option>1 time daily</option>
                        <option>2 time daily</option>
                        <option>3 time daily</option>
                        <option>4 time daily</option>
                        <option>as directed</option>
                        <option>as needed</option>
                        <option>as one dose</option>
                        <option>at bedtime</option>
                        <option>before every meal</option>
                        <option>bi-weekly</option>
                        <option>constant infusion</option>
                        <option>daily</option>
                        <option>daily as directed</option>
                        <option>every day</option>
                        <option>every month</option>
                        <option>every other day</option>
                        <option>every morning</option>
                        <option>every evening</option>
                        <option>every hour</option>
                        <option>every 2 hours</option>
                        <option>every 3 hours</option>
                        <option>every 4 hours</option>
                        <option>every 4 to 6 hours</option>
                        <option>every 4 to 6 minutes</option>
                        <option>every 4 to 8 hours</option>
                        <option>every 6 hours</option>
                        <option>every 8 hours</option>
                        <option>every 12 hours</option>
                        <option>every 24 hours</option>
                        <option>Monday</option>
                        <option>Tuesday</option>
                        <option>Wednesday</option>
                        <option>Thursday</option>
                        <option>Friday</option>
                        <option>Saturday</option>
                        <option>Sunday</option>
                        <option>every Monday, Wednesday, Friday, Sunday</option>
                        <option>every Tuesday, Thursday, Saturday</option>
                        <option>before breakfast, lunch, dinner</option>
                        <option>after breakfast, lunch, dinner</option>
                        <option>once a week</option>
                        <option>one time dose</option>
                        <option>three times a week</option>
                        <option>twice daily</option>
                        <option>two times a week</option>
                        <option>use as directed per instructions in pack</option>
                        <option>weekly</option>
                        </select>
                    </div>
                    <!-- Oral route only -->
                    <div v-if="(medFormData.route === 'Oral' || medFormData.route ==='Sublingual')" class="form-row">
                      <div class="form-group">
                      <label>Number of Tablets/Quantity</label>
                        <input
                          type="number"
                        min="1"
                        v-model.number="medFormData.quantity"
                      />
                      </div>
                  </div>
                  </div>
                  <div class="form-row admin-times">
                    <div class="form-group">
                      <div v-if="medTimeInputs.length > 0" class="form-group">
                        <label>Administration Times <span class="required">*</span></label>
                        <p class="admin-times-disclaimer" style="font-size: 0.85em; color: #666; margin-top: -5px; margin-bottom: 10px;">
                          These times can be modified later if needed.
                        </p>
                        <div
                          v-for="(_, index) in medTimeInputs"
                          :key="index"
                          class="time-input-row"
                        >
                          <input
                            type="time"
                            v-model="medTimeInputs[index]"
                            class="time-input"
                            required
                            aria-required="true"
                          />
                      </div>
                      </div>
                    </div>
                  </div>

                  <!-- Route + Duration row -->
                  <div class="form-row">
                    <div class="form-group">
                      <label>
                        Route <span class="required">*</span>
                      </label>
                      <select
                        v-model="medFormData.route"
                        required
                        aria-required="true"
                        @change="checkMedRouteSelection"
                      >
                        <option value="">Select route </option>
                        <option value="Oral">Oral</option>
                        <option value="Sublingual">Sublingual</option>
                        <option value="IVI Intravaginal">IVI Intravaginal</option>
                        <option value="SQ (Subcutaneous)">SQ (Subcutaneous)</option>
                        <option value="IM (Intramuscular)">IM (Intramuscular)</option>
                        <option value="IV (Intravenous)">IV (Intravenous)</option>
                        <option value="ID (Intradermal)">ID (Intradermal)</option>
                        <option value="TOP Topical">TOP Topical</option>
                        <option value="Neb/INH">Neb/INH</option>
                        <option value="NAS Intranasal">NAS Intranasal</option>
                        <option value="TD Transdermal">TD Transdermal</option>
                        <option value="Urethral">Urethral</option>
                        <option value="Rectally">Rectally</option>
                        <option value="Optic">Optic</option>
                        <option value="Otic">Otic</option>
                      </select>
                    </div>
                  </div>

                  <!-- NDC + RxNorm + Diagnosis row -->
                  <div class="form-row">
                    <div class="form-group" style="position: relative;">
                      <label>NDC Number</label>
                      <div style="display: flex; align-items: center; gap: 0.5rem;">
                        <input
                          type="text"
                          v-model="medFormData.ndcnumber"
                          placeholder="NDC Number"
                        />
                        <button type="button" class="verify-btn" :disabled="!medFormData.ndcnumber" @click="verifyNDC">Verify</button>
                          </div>
                      </div>
                    <div class="form-group">
                      <label>RX Norm</label>
                        <input
                          type="text"
                        v-model="medFormData.rxnorns"
                        placeholder="RX Norm"
                        />
                      </div>
                    <div class="form-group" style="position: relative;">
                      <label>Diagnosis <span class="required">*</span></label>
                      <DiagnosisCombobox
                        v-model="diagSearchDescrip"
                        :patient-id="orderPatientExternId"
                        :extra-diagnoses="stagedDiagComboboxOptions"
                        placeholder="Diagnosis"
                        required
                        @select="onOrderDiagnosisSelect"
                      />
                    </div>
                      </div>

                  <div class="form-row">
                    <div class="form-group">
                        <input
                        type="checkbox"
                        id="prnCheck-order"
                        v-model="medFormData.prn"
                      />
                      <label for="prnCheck-order">PRN (As Needed)</label>
                    </div>
                    <div class="form-group checkbox-group">
                      <div class="col-sm-12 col-md-6 col-xl-6">
                      <input type="checkbox"
                        id="newMedchkbx-order"
                        v-model="medFormData.newMedication"
                      />
                      <label for="newMedchkbx-order">New Medication</label>
                      </div>
                    </div>
                  </div>

                  <div class="form-row">
                    <div class="form-group">
                      <input
                            type="checkbox"
                        id="adminCheck-order"
                        v-model="medFormData.administration"
                      />
                      <label for="adminCheck-order">Administration</label>
                    </div>
                    <div class="form-group">
                      <input
                            type="checkbox"
                        id="prepourCheck-order"
                        v-model="medFormData.prepour"
                      />
                      <label for="prepourCheck-order">Prepour</label>
                    </div>
                    <div class="form-group">
                      <input
                            type="checkbox"
                        id="nebCheck-order"
                        v-model="medFormData.nebulizer"
                      />
                      <label for="nebCheck-order">Nebulizer</label>
                    </div>
                  </div>

                  <!-- IV Administration -->
                  <div v-if="showIvForm">
                    <h4>IV Administration</h4>

                    <!-- Fluid Type & VIA row -->
                    <div class="form-row">
                      <div class="form-group">
                        <label>Fluid Type</label>
                        <select v-model="medFormData.fluidType">
                          <option value="">Select fluid type</option>
                          <option>0.9% Normal Saline</option>
                          <option>D5W (5% Dextrose in Water)</option>
                          <option>Lactated Ringers (LR)</option>
                          <option>Half Normal Saline (0.45% NaCl)</option>
                        </select>
                      </div>
                      <div class="form-group">
                        <label>VIA</label>
                        <select v-model="medFormData.via">
                          <option value="">Select an option</option>
                          <option>Peripheral IV - Left Arm</option>
                          <option>Peripheral IV - Right Arm</option>
                          <option>PICC Line - Left</option>
                          <option>PICC Line - Right</option>
                          <option>Mid Line - Left</option>
                          <option>Mid Line - Right</option>
                          <option>Central Line - Left</option>
                          <option>Central Line - Right</option>
                        </select>
                      </div>
                    </div>

                    <!-- Volume + Rate row -->
                    <div class="form-row volume-rate-row">
                      <div class="form-group volume-group">
                        <label>Total Volume</label>
                        <div class="volume-row">
                          <input
                            list="volumeOptions"
                            v-model="medFormData.totalVolume"
                            class="volume-dropdown"
                            placeholder="e.g. 100"
                          />
                          <datalist id="volumeOptions">
                            <option value="10"></option>
                            <option value="100"></option>
                            <option value="250"></option>
                            <option value="500"></option>
                            <option value="1000"></option>
                          </datalist>
                          <select
                            class="volume-dropdown"
                            v-model="medFormData.totalVolumeUnit"
                          >
                            <option value="ml">ml</option>
                            <option value="liter">liter</option>
                          </select>
                      </div>
                      </div>
                      <div class="form-group">
                        <label>Rate</label>
                        <input
                          type="text"
                          v-model="medFormData.rate"
                          placeholder="50 (ml/hr)"
                        />
                      </div>
                      <div class="form-group">
                        <label>How Long (hrs)</label>
                        <input
                          type="text"
                          :value="medFormData.howLong"
                          disabled
                          placeholder="Computed"
                        />
                      </div>
                    </div>

                    <!-- Start/End Time row -->
                    <div class="form-row">
                      <div class="form-group">
                        <label>Start Time</label>
                        <input
                          type="time"
                          v-model="medFormData.startTime"
                          placeholder="HH:MM"
                        />
                      </div>
                      <div class="form-group">
                        <label>End Time</label>
                        <input
                          type="time"
                          :value="medFormData.endTime"
                          disabled
                        />
                      </div>
                    </div>
                  </div>

                  </div>

                  <MedicationPharmacyTabPanel
                    v-if="orderMedActiveTab === 'pharmacyInfo'"
                    v-model="medFormData"
                    :patient-extern-id="orderPharmPatientId"
                    :patient-account-number="orderPharmAccountNumber"
                  />

                  <!-- Form Actions -->
                  <div class="form-actions">
                        <input type="submit" id="savemedbtn" value="Save" />
                        <input
                          type="button"
                          id="cancelmedbtn"
                          @click="closeMed"
                          value="Cancel"
                        />
                  </div>
                </form>
                <!--Start Cuerrent Med Grid-->
                <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                  <div class="sortgrid">
                    <label id="switchlbl">View Current Medications</label
                    ><label id="switch"
                      ><input type="checkbox" id="toggleSearch" />
                      <span class="slider round"></span
                    ></label>
                  </div>
                  <!--end Column top-->
                  <!--end Column Row-->
                </div>
                <!--End Med Grid-->
              </div>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop">
                  <!--Start Colum-->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col1" class="coltext">Medication</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col2" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col3" class="coltext">Quantity</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Frequency</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col5" class="coltext">Duration</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col6" class="coltext">Start</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Route</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col8" class="coltext">Writer</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col9" class="coltext">Status</span>
                  </div>
                </div>
                <!--end Column top-->
                <template v-if="allMeds">
                  <div
                    v-for="med in sortedMedications"
                    :key="'med' + med.medentryid"
                    class="columnrow"
                    @click="showReAddMed(med)"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.medname }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.diagnose_code }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.available || med.med_amount || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.med_frequency }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.duration || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.med_startdate || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.route || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.writer || med.assignerName || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ med.status || med.medchangetype || 'Active' }}</span>
                    </div>
                  </div>
                </template>
                <!--end Column Row-->
              </div>
            </div>
            <!--Diagnosis Canvas-->
            <!-- <div
              id="diagnosiscanvas"
              :style="[activeTab == 2 ? { display: 'block' } : { display: 'none' }]"
            >
              <div class="diagnosisbtn_nav">
                <a
                  href="#Adddiagnosis"
                  title="Add Diagnosis"
                  class="transbuttons active"
                  id="adddiagbtn"
                  @click="showAddDiag"
                  >Add Diagnosis</a
                >
                <!~~ <a
                  href="#Edittransaction"
                  class="transbuttons"
                  title="Edit Transaction"
                  id="editdiagnosisbtn"
                  >Edit Diagnosis</a
                >
                <a
                  href="#Deletetransaction"
                  class="transbuttons"
                  title="Delete Transaction"
                  id="delettransbtn"
                  >Delete Diagnosis</a
                >
                <a
                  href="#Viewmedications"
                  class="transbuttons"
                  title="Veiw Medications"
                  id="viewdiagnosisbtn"
                  >View Current Diagnosis</a
                > ~~>
              </div>
              <div class="divider"></div>
              <form
                :id="'diagnosismodal' + patient.patient_id"
                @submit.prevent="saveDiag"
                class="diagnosismodal col-sm-12 col-md-12 col-lg-12"
              >
                <!~~ <section class="modalclose">
                  <a href="#close" title="close Modal" id="amodalclose">X</a>
                </section> ~~>
                <div class="modaltop">
                  <section class="diagtitlesec col-sm-12 col-md-6 col-lg-6">
                    <h3>Diagnosis</h3>
                  </section>
                </div>
                <div class="modalbottom">
                  <!~~ <div id="diagnostypeSec">
                    <label>Type:</label> <br />
                    <label>
                      <input type="checkbox" id="diagchkbox" />Diagnosis</label
                    ><br />
                    <label
                      ><input
                        type="checkbox"
                        id="procedurechkbox"
                      />Proceedure</label
                    >
                  </div> ~~>
                  <div class="icd10second col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-5">
                      <label>ICD-10 Code/Description *</label>
                      <!~~ <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> ~~>
                      <br />
                      <input
                        required
                        name="icdCode"
                        type="text"
                        id="srchnlookupterms"
                        title="icd-10 diagnosis field"
                        v-model="diagSearchDescrip"
                        :placeholder="
                          icdSearch
                            ? 'Type in your ICD code or a description'
                            : 'Type in your ICD Code'
                        "
                        @keyup.prevent="showDiagSearch"
                      />
                      <div
                        v-if="searchedDiags && searchedDiags.length != 0"
                        class="icd10listcontainer col-lg-12"
                      >
                        <div
                          v-for="diag in searchedDiags"
                          class="icd10srchlist"
                          :key="diag.code"
                          @click="clickDiag(diag)"
                        >
                          <span id="icdcode">{{ diag.code }}</span> -
                          <span id="icddesript">{{ diag.description }}</span>
                        </div>
                      </div>
                      <!~~ <a href="#searchicon"
                        ><img
                          src="https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-search-512.png"
                          width="20"
                          height="20"
                      /></a> ~~>
                    </div>
                    <!~~ <label>Onset/Exacerbation *</label><br />
                      <label>
                        <input type="radio" id="onsetkbox" name="onOrExac" value="Onset" />Onset</label
                      >
                      <label
                        ><input
                          type="radio"
                          id="excaberationchkbox"
                          name="onOrExac"
                          value="Exacerbation"
                        />Exacerbation</label ~~>
                    <div id="icdthirdopt" class="col-sm-12 col-md-4 col-lg-4">
                      <label>Date *</label><br />
                      <input type="date" id="diagnosisDate" required name="date" />
                    </div>
                  </div>
                  <div class="icd10thrid col-sm-12 col-lg-12"></div>
                  <div class="icd10fifth col-sm-12 col-lg-12">
                    <div id="icdsfrthopt" class="col-sm-12 col-md-12 col-lg-12">
                      <input type="submit" id="savediagnbtn" value="Save" />
                      <input
                        type="button"
                        id="canceldiagbtn"
                        value="Cancel"
                        @click="closeDiag"
                      />
                    </div>
                  </div>
                </div>
                <!~~end Order Grid for Modal~~>
              </form>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop" id="diagColumnTop">
                  <!~~Start Colum~~>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col1" class="coltext">Order ID</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col2" class="coltext">Patient ID</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col3" class="coltext">Diagnosis Code</span>
                  </div>
                  <!~~ <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col"
                  >
                    <span id="col4" class="coltext">Diagnosis Type</span>
                  </div> ~~>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col4" class="coltext">Control System Rating</span>
                  </div>
                  <!~~ <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col"
                  >
                    <span id="col6" class="coltext">Onset/Exacerbation</span>
                  </div> ~~>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col7" class="coltext">Date</span>
                  </div>
                  <!~~ <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col"
                  >
                    <span id="col8" class="coltext">Alternative Route</span>
                  </div> ~~>
                </div>
                <!~~end Column top~~>
                <template v-if="allDiags">
                  <div
                    v-for="(diag, index) in allDiags.slice().reverse()"
                    :key="'diag' + diag.diagnosis_code + index"
                    class="columnrow"
                  >
                    <!~~start column row~~>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ diag.order_id }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ diag.patientID }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ diag.diagnosis_code }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{
                        diag.system_controlrating
                      }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ diag.diagnosis_date }}</span>
                    </div>
                    <!~~ <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext">12 mil</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext msgiconbtn">33 liters</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext">Pending</span>
                    </div> ~~>
                  </div>
                </template>
                <!~~end Column Row~~>
              </div>
            </div> -->
            <div
              id="diagnosiscanvas"
              v-show="activeTab == 3"
            >
              <div class="diagnosisbtn_nav">
                <a
                  title="Add Procedure"
                  class="transbuttons active"
                  id="adddiagbtn"
                  @click="showAddProc"
                  >Add Procedure</a
                >
                <!-- <a
                  href="#Edittransaction"
                  class="transbuttons"
                  title="Edit Transaction"
                  id="editdiagnosisbtn"
                  >Edit Diagnosis</a
                >
                <a
                  href="#Deletetransaction"
                  class="transbuttons"
                  title="Delete Transaction"
                  id="delettransbtn"
                  >Delete Diagnosis</a
                >
                <a
                  href="#Viewmedications"
                  class="transbuttons"
                  title="Veiw Medications"
                  id="viewdiagnosisbtn"
                  >View Current Diagnosis</a
                > -->
              </div>
              <div class="divider"><span>New Procedures</span></div>
              <div class="order-grid new-or-edit-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop" id="diagColumnTop">
                  <!--Start Colum-->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
                    <span id="col1" class="coltext">Procedure</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col2" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
                    <span id="col3" class="coltext">Instruction</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Start Date</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col5" class="coltext">End Date</span>
                  </div>
                </div>
                <template v-if="newProcs.length != 0">
                  <div
                    v-for="(proc, index) in newProcs"
                    :key="'newProc' + index"
                    class="columnrow"
                  >
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
                      <span id="col1" class="coltext">{{ proc.code }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="col2" class="coltext">{{
                        `${proc.diagCode} - ${proc.diagDescription}`
                      }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
                      <span id="col3" class="coltext">{{ proc.instructions }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="col4" class="coltext">{{ proc.startDate || "" }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="col5" class="coltext">{{ proc.endDate || "" }}</span>
                    </div>
                  </div>
                </template>
              </div>
              <div class="divider"><span>Previously Ordered Procedures</span></div>
              <form
                :id="'procmodal' + patient.patient_id"
                @submit.prevent="addNewProc"
                class="diagnosismodal col-sm-12 col-md-12 col-lg-12"
              >
                <!-- <section class="modalclose">
                  <a href="#close" title="close Modal" id="amodalclose">X</a>
                </section> -->
                <div class="modaltop">
                  <section class="diagtitlesec col-sm-12 col-md-6 col-lg-6">
                    <h3>Procedure</h3>
                  </section>
                </div>
                <div class="modalbottom">
                  <!-- <div id="diagnostypeSec">
                    <label>Type:</label> <br />
                    <label>
                      <input type="checkbox" id="diagchkbox" />Diagnosis</label
                    ><br />
                    <label
                      ><input
                        type="checkbox"
                        id="procedurechkbox"
                      />Proceedure</label
                    >
                  </div> -->
                  <div class="icd10second col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Procedure Description <span class="required">*</span></label>
                      <!-- <label id="srchbylbl">{{icdSearch ? "Search By ICD-10 Description" : "Search By ICD-10 Code"}}</label
                      ><label id="switch"
                        ><input type="checkbox" id="toggleSearch" v-model="icdSearch"/></label> -->
                      <br />
                      <input
                        required
                        name="procCode"
                        type="text"
                        id="srchnlookupterms"
                        title="cpt proc field"
                        v-model="procSearchDescrip"
                        placeholder="Type in your CPT description"
                        @keyup.prevent="showProcSearch"
                      />
                      <input
                        type="text"
                        id="officialProc"
                        name="officialProc"
                        placeholder="Official Procedure Name"
                        v-model="officialProc"
                        readonly
                      />
                      <!-- <div v-if="searchedProcs && searchedProcs.length != 0" class="icd10listcontainer col-lg-12">
                        <div v-for="proc in searchedProcs" class="icd10srchlist" :key="proc.code"
                          @click="clickProc(proc)">
                          <span id="icdcode">{{ proc.code }}</span> - <span id="icddesript">{{ proc.description }}</span>
                        </div>
                      </div> -->
                      <!-- <a href="#searchicon"
                        ><img
                          src="https://cdn4.iconfinder.com/data/icons/ionicons/512/icon-ios7-search-512.png"
                          width="20"
                          height="20"
                      /></a> -->
                    </div>
                    <div id="icdsectopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>ICD-10 Description <span class="required">*</span></label>
                      <br />
                      <DiagnosisCombobox
                        v-model="diagSearchDescrip"
                        :patient-id="orderPatientExternId"
                        :extra-diagnoses="stagedDiagComboboxOptions"
                        placeholder="Type in your ICD code or a description"
                        required
                        @select="onOrderDiagnosisSelect"
                      />
                    </div>
                    <div id="icdthirdopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Start Date</label><br />
                      <input type="date" id="diagnosisStartDate" name="startDt" />
                    </div>
                    <div id="icdfourthopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>End Date</label><br />
                      <input type="date" id="diagnosisEndDate" name="endDt" />
                    </div>
                  </div>
                  <div class="icd10fourth col-sm-12 col-lg-12">
                    <div id="icdfirstopt" class="col-sm-12 col-md-4 col-lg-3">
                      <label>Instruction</label>
                      <textarea
                        id="instruction"
                        name="instruction"
                        cols="100"
                        type="text"
                      />
                    </div>
                  </div>
                  <div class="icd10thrid col-sm-12 col-lg-12">
                    <ul class="list">
                      <template v-if="activeSearch === 'procedure'">
                        <li
                          v-for="(procedure, index) in paginatedData"
                          :key="index"
                          class="list__item"
                        >
                          <a class="list__link" @click="clickProc(procedure)">
                            <strong class="lookup-result-title">{{
                              procedure.description
                            }}</strong>
                            <small class="lookup-result-code">{{ procedure.code }}</small>
                          </a>
                        </li>
                      </template>
                      <template v-if="activeSearch === 'diagnosis'">
                        <li
                          v-for="(diagnosis, index) in paginatedData"
                          :key="index"
                          class="list__item"
                        >
                          <a class="list__link" @click="clickDiag(diagnosis)">
                            <strong class="lookup-result-title">{{
                              diagnosis.description
                            }}</strong>
                            <small class="lookup-result-code">{{ diagnosis.code }}</small>
                          </a>
                        </li>
                      </template>
                    </ul>
                    <div v-if="searchedProcs.length > 0" class="pagination-controls">
                      <button
                        :disabled="pageNumber === 0"
                        @click="prevPage"
                        class="btn btn-prev"
                      >
                        Previous
                      </button>

                      <input
                        type="text"
                        v-model="currPageNumber"
                        id="currentPageNumber"
                        class="pagination-page-input"
                      />
                      <span class="pagination-total">/{{ pageCount() }}</span>
                      <button @click="toPage(currPageNumber - 1)" class="btn btn-go">
                        Go
                      </button>

                      <button
                        :disabled="pageNumber >= pageCount() - 1"
                        @click="nextPage"
                        class="btn btn-next"
                      >
                        Next
                      </button>
                    </div>
                    <div v-if="searchedDiags.length > 0" class="pagination-controls">
                      <button
                        :disabled="pageNumber === 0"
                        @click="prevPage"
                        class="btn btn-prev"
                      >
                        Previous
                      </button>

                      <input
                        type="text"
                        v-model="currPageNumber"
                        id="currentPageNumber"
                        class="pagination-page-input"
                      />
                      <span class="pagination-total">/{{ pageCount() }}</span>
                      <button @click="toPage(currPageNumber - 1)" class="btn btn-go">
                        Go
                      </button>

                      <button
                        :disabled="pageNumber >= pageCount() - 1"
                        @click="nextPage"
                        class="btn btn-next"
                      >
                        Next
                      </button>
                    </div>
                  </div>
                  <div class="icd10fifth col-sm-12 col-lg-12">
                    <div id="icdsfrthopt" class="col-sm-12 col-md-12 col-lg-12">
                      <input type="submit" id="savediagnbtn" value="Save" />
                      <input
                        type="button"
                        id="canceldiagbtn"
                        value="Cancel"
                        @click="closeProc"
                      />
                    </div>
                  </div>
                </div>
                <!--end Order Grid for Modal-->
              </form>
              <div class="order-grid col-sm-12 col-md-12 col-lg-12">
                <div class="columntop" id="diagColumnTop">
                  <!--Start Colum-->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-col">
                    <span id="col3" class="coltext">Procedure</span>
                  </div>
                  <!-- <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col"
                  >
                    <span id="col4" class="coltext">Diagnosis Type</span>
                  </div> -->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col4" class="coltext">Diagnosis</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-col">
                    <span id="col2" class="coltext">Instruction</span>
                  </div>
                  <!-- <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col"
                  >
                    <span id="col6" class="coltext">Onset/Exacerbation</span>
                  </div> -->
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Start Date</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">End Date</span>
                  </div>
                  <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col">
                    <span id="col7" class="coltext">Writer</span>
                  </div>
                  <!-- <div
                    class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-col"
                  >
                    <span id="col8" class="coltext">Alternative Route</span>
                  </div> -->
                </div>
                <!--end Column top-->
                <template v-if="allProcs">
                  <div
                    v-for="(proc, index) in sortedProcedures"
                    :key="'diag' + index"
                    class="columnrow"
                    @click="showReAddProc(proc)"
                  >
                    <!--start column row-->
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-4 top-row">
                      <span id="row" class="coltext">{{ proc.procedure_code || proc.procShorthand || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ proc.diagnosis_code || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-3 top-row">
                      <span id="row" class="coltext">{{ proc.instruction || proc.instructions || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ proc.diagnosis_date || proc.startDate || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ proc.end_date || proc.endDate || '' }}</span>
                    </div>
                    <div class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row">
                      <span id="row" class="coltext">{{ proc.writer || proc.assignerName || '' }}</span>
                    </div>
                    <!-- <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext">12 mil</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext msgiconbtn">33 liters</span>
                    </div>
                    <div
                      class="col-xs-2 col-sm-4 col-md-2 col-lg-2 col-xl-2 top-row"
                    >
                      <span id="row" class="coltext">Pending</span>
                    </div> -->
                  </div>
                </template>
                <!--end Column Row-->
              </div>
            </div>
            <!--end Diagnosis Canvas-->
            <!--Signature <Field-->
            <div class="col-sm-12 col-md-12 col-lg-12 sig-wrapper">
              <div
                v-if="orderType == 'Nurses Order' || orderType == 'Verbal Order'"
                class="nursig-wrapper"
              >
                <div class="nursename">
                  <label>Nurse Name:</label>
                  <input type="text" v-model="nursesignature" id="nursename" required />
                  <input
                    v-if="pendingordData"
                    type="text"
                    v-model="pendingordDataChild.firstname"
                    id="nursename"
                    required
                  />
                </div>
                <div class="nrssigdate">
                  <label>Signature Date:</label
                  ><input type="date" v-model="nursesigDate" id="nursdatefld" />
                </div>
              </div>
              <div v-else class="provsig-wrapper">
                <div class="provsig-wrapper">
                  <div class="provname">
                    <label>Provider Name:</label>
                    <input v-model="providersig" type="text" id="provname" required />
                  </div>
                  <div class="provsigdate">
                    <label>Signature Date:</label
                    ><input
                      v-model="providersigDate"
                      type="date"
                      id="provdatefld"
                      required
                    />
                  </div>
                </div>
              </div>
            </div>
            <!--</Field-->
            <div class="col-sm-12 col-md-12 col-lg-12 ordclosebtn">
              <input
                type="button"
                value="Cancel"
                id="cancelbtn"
                class="cancelbtn"
                @click="cancelOrder"
              />
              <input
                type="submit"
                value="Save & Close"
                id="ordersavebtn"
                class="orderbtn"
                :disabled="!orderHasMedOrProc"
                :title="orderHasMedOrProc ? 'Submit order' : 'Add at least one medication or procedure before saving'"
              />
            </div>
          </div>
        </form>
      </div>
      <!--endcontainer-->
    </div>
    <!-- </body> -->
  </div>
  <!-- @TODO: Mobile orders must be implemented for new structure -->
  <div v-else class="form-container">
    <form :id="'orderform' + patient.patient_id" @submit.prevent="saveNewOrder()">
      <div class="form-group">
        <label for="order-date">Order Date <span class="required">*</span></label>
        <input type="date" id="order-date" name="date" required v-model="orderFormDate" />
      </div>
      <div class="form-group">
        <label for="order-time">Order Time <span class="required">*</span></label>
        <input type="time" id="order-time" name="time" required v-model="orderFormTime" />
      </div>
      <div class="form-group">
        <label for="order-type">Order Type <span class="required">*</span></label>
        <select id="order-type" name="ordertype" required v-model="orderType">
          <option value="Physicians Order">Physicians Order</option>
          <option value="Nurses Order">Nurses Order</option>
          <option value="Verbal Order">Verbal Order</option>
        </select>
      </div>
      <div class="form-group">
        <label for="abn-delivered">ABN Delivered? <span class="required">*</span></label>
        <select id="abn-delivered" name="abn" required>
          <option value="0">N/A</option>
          <option value="2">Yes</option>
          <option value="1">No</option>
        </select>
      </div>
      <div class="form-group">
        <label for="order-read-back"
          >Order Read Back to Physician <span class="required">*</span></label
        >
        <select id="order-read-back" name="phyAgent" required>
          <option value="NA">N/A</option>
          <option value="No">No</option>
          <option value="Yes">Yes</option>
        </select>
      </div>
      <div class="form-group primary-physician-chooser">
        <span class="primary-physician-chooser-heading"
          >Primary Physician <span class="required">*</span></span
        >
        <p v-if="ifNurseAccount || ifAdministrator" class="primary-physician-chooser-hint">
          Choose one: pick an assigned provider, or look up someone else by name.
        </p>
        <p v-else class="primary-physician-chooser-hint">
          Type a provider name to look them up by NPI.
        </p>

        <div v-if="ifNurseAccount || ifAdministrator" class="primary-physician-chooser-side">
          <label for="assigned-provider" class="primary-physician-chooser-title"
            >Select an Assigned Provider</label
          >
          <select
            id="assigned-provider"
            v-model="loadedProvider"
            class="assigned-provider-select"
            :disabled="!pastProvloaded || !pastProvar?.length"
            @change="onAssignedProviderChange"
          >
            <option value="">
              {{ pastProvloaded && pastProvar?.length ? "Select a provider…" : "No assigned providers" }}
            </option>
            <option
              v-for="(prov, index) in pastProvar"
              :key="prov.id ?? index"
              :value="prov"
            >
              {{ prov.firstname ?? prov.first_name ?? prov.name }} {{ prov.lastname }}
            </option>
          </select>
        </div>

        <div
          v-if="ifNurseAccount || ifAdministrator"
          class="primary-physician-chooser-or"
          aria-hidden="true"
        >
          or
        </div>

        <div class="primary-physician-chooser-side">
          <label for="primary-physician" class="primary-physician-chooser-title"
            >Look Up a Provider (NPI)</label
          >
          <div class="primary-physician-lookup">
            <input
              v-model="npiSearch"
              type="text"
              id="primary-physician"
              name="primary-physician"
              required
              placeholder="Type provider name to search"
              autocomplete="off"
              @keyup.prevent="onPrimaryPhysicianLookupInput"
              @focus="isPrimaryPhysicianFocused = true"
            />
            <div v-if="searchedNpis" class="npinamemodal mobile-npi-results">
              <div
                v-for="(npi, index) in searchedNpis"
                class="additionalnameli"
                :key="index + 'npi-m-' + npi.npinumber"
                @click="selectNpiFromLookup(npi)"
              >
                {{ npi.name }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="primary-physician-details">
        <button
          type="button"
          class="primary-physician-details-toggle"
          :aria-expanded="showPrimaryPhysicianDetails"
          @click="showPrimaryPhysicianDetails = !showPrimaryPhysicianDetails"
        >
          <span>Primary physician details</span>
          <span class="primary-physician-details-chevron" aria-hidden="true">{{
            showPrimaryPhysicianDetails ? "▾" : "▸"
          }}</span>
        </button>
        <div v-show="showPrimaryPhysicianDetails" class="primary-physician-details-panel">
          <div class="form-group">
            <label for="email">E-mail <span class="required">*</span></label>
            <input
              v-model="npiEmail"
              name="email"
              type="email"
              id="email"
              required
              autocomplete="email"
            />
          </div>
          <div class="form-group">
            <label for="npi-number">NPI Number <span class="required">*</span></label>
            <input v-model="npi" type="text" id="npi-number" name="npi-number" required />
          </div>
          <div class="form-group">
            <label for="address">Address <span class="required">*</span></label>
            <div class="primary-physician-lookup">
              <input v-model="npiAddress" type="text" id="address" name="address" required />
              <div v-if="searchedAddresses" class="npiadditionaladdr mobile-npi-results">
                <div
                  v-for="(addr, index) in searchedAddresses"
                  class="additionalnameli"
                  :key="'addr-m-' + index"
                  @click="selectAddr(addr)"
                >
                  {{ addr.address }}
                </div>
              </div>
            </div>
          </div>
          <div class="form-group">
            <label for="order-phone-number">Order Phone Number</label>
            <input
              v-model="npiPhone"
              type="text"
              id="order-phone-number"
              name="order-phone-number"
            />
          </div>
          <div class="form-group">
            <label for="order-fax-number">Order Fax Number</label>
            <input
              v-model="npiFax"
              type="text"
              id="order-fax-number"
              name="order-fax-number"
            />
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="secondary-physician">Secondary Physician</label>
        <input type="text" name="secphysician" id="secphysician" class="secphysician" />
      </div>
      <div class="form-group mobile-checkbox-row">
        <label class="mobile-inline-checkbox" for="send-to-physicians">
          <input
            v-model="sendtophys"
            type="checkbox"
            id="send-to-physicians"
            name="send-to-physicians"
          />
          Send To Physicians
        </label>
        <label class="mobile-inline-checkbox" for="wound-care-order">
          <input
            v-model="woundcare"
            type="checkbox"
            id="wound-care-order"
            name="wound-care-order"
          />
          Wound Care Order
        </label>
      </div>
      <div class="tab-container">
        <button type="button" @click="activeMobileTab = 'description'" class="tab-button">
          Order Description
        </button>
        <button type="button" @click="activeMobileTab = 'medication'" class="tab-button">
          Medications
        </button>
        <button type="button" @click="activeMobileTab = 'procedure'" class="tab-button">
          Procedure
        </button>
      </div>
      <div v-if="activeMobileTab" class="tab-content">
        <template v-if="activeMobileTab == 'description'">
          <EditorComponent v-model="message" editorStype="height: 300px">
            <template #toolbar>
              <span class="ql-formats">
                <button class="ql-bold"></button>
                <button class="ql-italic"></button>
                <button class="ql-underline"></button>
              </span>
            </template>
          </EditorComponent>
        </template>
        <template v-if="activeMobileTab == 'medication'">
          <input
            type="button"
            class="Mobile-button Mobile-add"
            value="Add Medication"
            @click="showAddMed"
          />
          <div v-if="newMeds.length" class="table-container">
            <div class="added-items-banner">Added Medications</div>
            <div class="accordion">
              <div
                v-for="(med, index) in newMeds.slice().reverse()"
                :key="'new-med-' + index"
                class="accordion-item"
              >
                <button type="button" class="accordion-button">
                  {{ med.medShorthand || med.medName }}
                </button>
                <div class="accordion-content">
                  <p><b>Medication: </b>{{ med.medName || "" }}</p>
                  <p><b>Quantity: </b>{{ med.quantity || "" }}</p>
                  <p><b>Frequency: </b>{{ med.frequency || "" }}</p>
                  <p>
                    <b>Diagnosis: </b
                    >{{
                      med.diagDescription ||
                      (med.diagCode ? `${med.diagCode}` : "") ||
                      ""
                    }}
                  </p>
                  <p><b>Route: </b>{{ med.route || "" }}</p>
                  <p>{{ `${med.startDate || ""} to ${med.endDate || ""}` }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
        <template v-if="activeMobileTab == 'procedure'">
          <input
            type="button"
            class="Mobile-button Mobile-add"
            value="Add Procedure"
            @click="showAddProc"
          />
          <div v-if="newProcs.length" class="table-container">
            <div class="added-items-banner">Added Procedures</div>
            <div class="accordion">
              <div
                v-for="(proc, index) in newProcs.slice().reverse()"
                :key="'new-proc-' + index"
                class="accordion-item"
              >
                <button type="button" class="accordion-button">
                  {{ proc.shorthand || proc.code }}
                </button>
                <div class="accordion-content">
                  <p><b>Procedure: </b>{{ proc.code || "" }}</p>
                  <p>
                    <b>Diagnosis: </b
                    >{{
                      proc.diagDescription ||
                      (proc.diagCode ? `${proc.diagCode}` : "") ||
                      ""
                    }}
                  </p>
                  <p><b>Instruction: </b>{{ proc.instructions || "" }}</p>
                  <p>{{ `${proc.startDate || ""} to ${proc.endDate || ""}` }}</p>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
      <div class="Mobile-button-group">
        <input
          type="button"
          class="Mobile-button Mobile-cancel"
          value="Cancel"
          @click="cancelOrder"
        />
        <input type="submit" class="Mobile-button Mobile-save" value="Save & Close" 
        :disabled="!orderHasMedOrProc" 
        :title="orderHasMedOrProc ? 'Submit order' : 'Add at least one medication or procedure before saving'" />
      </div>
    </form>

    <AddMedicationForm
      :show="mobileSubModal === 'med'"
      :pastProvloaded="pastProvloaded"
      :pastProvar="pastProvar"
      :isEditMedication="false"
      :isAddNewMed="true"
      :ifStatusIsChange="false"
      :editFormdata="null"
      :extra-diagnoses="stagedDiagComboboxOptions"
      :patient-id="orderPatientExternId"
      :hide-provider-and-prescription="true"
      modal-title="Add Medication"
      @close="closeMed"
      @save="handleMobileOrderMedSave"
      @loadprov="getSavedProviders"
    />

    <Teleport to="body">
      <!-- Procedure sub-modal -->
      <div
        v-if="mobileSubModal === 'proc'"
        class="mobile-order-submodal-overlay"
        @click.self="closeProc"
      >
        <div
          class="mobile-order-submodal"
          role="dialog"
          aria-modal="true"
          :aria-labelledby="'mobile-proc-title-' + patient.patient_id"
        >
          <div class="mobile-order-submodal-header">
            <h2 :id="'mobile-proc-title-' + patient.patient_id">
              {{ `${patient.first_name} ${patient.lastname}` }}
            </h2>
          </div>
          <form
            class="mobile-order-submodal-form Mobile-proc"
            :id="'procmodal' + patient.patient_id"
            @submit.prevent="saveProc"
          >
            <div class="mobile-order-submodal-body">
              <div class="form-group lookup-field">
                <label>Procedure Description <span class="required">*</span></label>
                <input
                  required
                  name="procCode"
                  type="text"
                  v-model="procSearchDescrip"
                  @keyup.prevent="showProcSearch"
                  placeholder="Type in your CPT description"
                  autocomplete="off"
                />
                <div
                  v-if="searchedProcs && searchedProcs.length"
                  :class="['lookup-results', 'searchresult' + patient.patient_id]"
                  id="procsearchresult"
                >
                  <div
                    v-for="proc in searchedProcs"
                    class="lookup-result-item"
                    :key="proc.procid || proc.code"
                    @click="clickProc(proc)"
                  >
                    <strong class="lookup-result-title">{{ proc.description }}</strong>
                    <small class="lookup-result-code">{{ proc.code }}</small>
                  </div>
                </div>
                <input
                  type="text"
                  id="officialProc"
                  name="officialProc"
                  placeholder="Official Procedure Name"
                  v-model="officialProc"
                  readonly
                />
              </div>
              <div class="form-group lookup-field">
                <label>ICD-10 Description <span class="required">*</span></label>
                <DiagnosisCombobox
                  v-model="diagSearchDescrip"
                  :patient-id="orderPatientExternId"
                  :extra-diagnoses="stagedDiagComboboxOptions"
                  placeholder="Type in your ICD code or a description"
                  required
                  @select="onOrderDiagnosisSelect"
                />
              </div>
              <div class="form-group">
                <label>Start Date <span class="required">*</span></label>
                <input type="date" name="startDt" required />
              </div>
              <div class="form-group">
                <label>End Date</label>
                <input type="date" name="endDt" />
              </div>
              <div class="form-group">
                <label>Instruction</label>
                <textarea name="instruction" rows="3"></textarea>
              </div>
            </div>
            <div class="mobile-order-submodal-footer">
              <button type="submit" class="save-btn">Save</button>
              <button type="button" class="cancel-btn" @click="closeProc">Cancel</button>
            </div>
          </form>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script>
import { mapGetters} from "vuex";
import { mapState } from "pinia";
import {ref} from "vue";
import { CURR_API, OTHER_API } from "@/constants/apis";
import axios from "axios";
import $ from "jquery";
import { medTimes } from "@/constants/med-times";
import { PastProvarItem } from './types';
import MedicationPharmacyTabPanel from "@/components/private-layouts/currents/MedicationPharmacyTabPanel.vue";
import AddMedicationForm from "@/components/private-layouts/currents/AddMedicationForm.vue";
import DiagnosisCombobox, {
  formatDiagnosisLabel,
  parseDiagnosisLabel,
} from "@/components/includes/DiagnosisCombobox.vue";
import { useSessionSelfStore } from "@/stores/sessionSelf";
import { sessionActorFrom } from "@/utils/sessionIdentity";
import { normalizeSelfProfile } from "@/utils/selfProfileForm";
//const pastProvloaded = false;
//const pastProvar =[];
export default {
  name: "OrderPopup",
  components: { MedicationPharmacyTabPanel, AddMedicationForm, DiagnosisCombobox },
  emits: ['close'],
  data() {
    return {
      mT: null,
      message: "", // Order's message/textfield value
      activeTab: 1, // Switch that focuses on right tab; 0 == order, 1 == medications, 2 == diagnosis, 3 == procedure
      sendtophys: false, // Checkbox for sending order to physician
      woundcare: false, // Checkbox for wound care
      addedItem: false, // True if med/diag/proc added

      npiSearch: "", // Primary physician search textfield value
      searchedNpis: null, // List of physicians retrieved via npiSearch
      searchedAddresses: null, // List of addresses associated with chosen physician
      isPrimaryPhysicianFocused: false, // Track if Primary Physician input is focused
      npi: "", // NPI of chosen physician
      npiAddress: "", // Address of chosen physician
      npiPhone: "", // Phone number of chosen physician
      npiFax: "", // Fax number of chosen physician
      npiEmail: "", // Email of chosen physician
      // showMed: false,               // Checkbox that activates Medications tab
      medicationSearchCode: "", // Medication search code value
      medicationSearchDescrip: "", // Medication search description (textfield) value
      searchedMeds: [], // List of medications retrieved via medicationSearch
      allMeds: null, // List of medications already saved for patient
      officialMed: "",
      newMeds: [], // List of medications that are newly added/edited
      orderMedActiveTab: "medInfo",
      // New medication form data
      medFormData: {
        medicationName: "",
        ndcnumber: "",
        rxnorns: "",
        diagnosis: "",
        diagdescription: "",
        dosage: "",
        unitType: "",
        frequency: "",
        route: "Oral",
        prn: false,
        newMedication: false,
        quantity: 0,
        duration: "",
        refills: 0,
        instructions: "",
        startDate: "",
        endDate: "",
        administration: false,
        prepour: false,
        nebulizer: false,
        // IV fields
        fluidType: "",
        totalVolume: "",
        totalVolumeUnit: "ml",
        rate: "",
        howLong: "",
        startTime: "",
        endTime: "",
        via: "",
        pharmacyName: "",
        pharmacyDea: "",
        pharmacyNpi: "",
        pharmacyAddress: "",
        pharmacyOffice: "",
        pharmacyCell: "",
        pharmacyEmail: ""
      },
      medTimeInputs: [], // Administration times array
      medSearchResults: [], // FDA medication search results
      showMedSuggestions: false,
      medSearchMode: "generic", // 'brand' or 'generic'
      medDebounceTimer: null,
      showIvForm: false,
      dosageOptions: [
        "Actuation","Ampule","Application","Applicator","Auto-Injector","Bar","Capful","Caplet","Capsule",
        "Cartridge","Centimeter","Disk","Dropperful","Each","Film","Fluid Ounce","Gallon","Gram","Gum","Implant",
        "Inch","Inhalation","Injection","Insert","Liter","Lollipop","Lozenge","Metric Drop","Microgram",
        "Milliequivalent","Milligram","Milliliter","Nebule","Ounce","Package","Packet","Pad","Patch","Pellet",
        "Pill","Pint","Pre-filled Pen Syringe","Puff","Pump","Ring","Sachet","Scoopful","Sponge","Spray","Stick",
        "Strip","Suppository","Swab","Syringe","Tablet","Troche","Unit","Vial","Wafer"
      ],

      // showDiag: false,              // Checkbox that activates Diagnosis tab
      savedProviders: [],
      pastProvar:[], //array for past loaded Providers
      loadedProvider: "",
      loadedProviderIndex: null,
      pastProvloaded:false,//boolean for show UI;
      ifNurseAccount:false,
      ifAdministrator:false, //Administrator Boolean that will show the Provider Dropdown
      isAccountVerified:false, // Boolean (Imported from AdddMedicatin module) KW
      showAccountStatTag:'', //Show Account Status Tag (IMported FRom AddMedication ) KW
      isacntRequestBtnDisabled: false, // Accnt Request Disable Button Boolean KW
      isAccountVerified:false, //is Account Verified Boolean - NPI Lookup (Imported from MA)KW
      accntRequestEmail: '',// Accnt Creation email field (clear email field) KW
      accounterrorText:'', //Account Error Text (notify user with accnt errors) (Imported from MA-KW)
      icdSearch: true, // Switch for searching by either icd description (true) or code only (false)
      diagSearchCode: "", // ICD-10 search code value
      diagSearchDescrip: "", // ICD-10 search description (textfield) value
      searchedDiags: [], // List of ICD codes retrieved via icdSearch
      allDiags: null, // List of diagnosis already saved for patient
      allNewDiags: [], // List of diagnoses that are newly added

      // showProc: false,              // Checkbox that activates Procedure tab
      allProcs: null, // List of procedures already saved for patient
      procSearchDescrip: "", // CPT search descriptions (textfield) value
      searchedProcs: [], // List of CPT codes retrieved via procSearch
      officialProc: "",
      newProcs: [], // List of procedures that are newly added/edited

      pageNumber: 0,
      size: 5,
      currPageNumber: 1,
      paginatedData: [],
      activeSearch: "",
     
      manualAllergies: [],
      nursesignature: "",
      nursesigDate: null,
      providersig: "", //providersig
      providersigDate: null, //Provider Signature Date
      orderFormDate: "",
      orderFormTime: "",
      activeMobileTab: "",
      mobileSubModal: null, // 'med' | 'proc' when a mobile add sub-modal is open
      showPrimaryPhysicianDetails: false,
      diagSelectSource: null,

      orderType: "Physicians Order", // Needed to determine which sig field to show
      pendingordDataChild: this.pendingordData,
      accountType: "", // Store the account type
      mountAccntTypeLicense:"",//Store the license of the provider that is returned during accountType Lookup
      today: this.todayYYYYMMDD()
    };
  },
  props: {
    patient: {},
    orderNum: null,
    pendingordData: [],
    prov: {},
  },
  computed: {
    ...mapGetters("login", {
      user: "getUser",
      allData: "getAllData",
    }),
    // Options API: track MySQL self so charting does not treat the patient as the ordering actor.
    ...mapState(useSessionSelfStore, {
      sessionSelfProfile: "profile",
    }),
    /**
     * Logged-in person writing the order. Vuex getUser is user∪patient, so on OrdersPage
     * (viewingPatientChart) it becomes the chart patient and blanks NPI / order type / signature.
     * Prefer sessionSelf; fall back to getUser only when not charting (HomeGrid's historical path).
     */
    orderingActor() {
      const actor = sessionActorFrom(this.allData, this.sessionSelfProfile);
      const self = normalizeSelfProfile(this.sessionSelfProfile || {});
      const charting = !!(this.allData && this.allData.viewingPatientChart);
      const manager = (this.allData && this.allData.manager) || {};
      const fromUser = !charting;
      return {
        firstName: actor.firstName || (fromUser ? this.user.firstName : manager.firstName || manager.fname) || "",
        lastName: actor.lastName || (fromUser ? this.user.lastName : manager.lastName || manager.lname) || "",
        externId: actor.externId || (fromUser ? this.user.externId : manager.externId || manager.externid) || "",
        externId2: actor.externId2 || (fromUser ? this.user.externId2 : manager.externId2 || manager.externid2) || "",
        npi: self.npi || (fromUser ? this.user.npi : manager.npi) || "",
        address: self.address || (fromUser ? this.user.address : manager.address) || "",
        phone1: self.phone1 || actor.phone1 || (fromUser ? this.user.phone1 : manager.phone1) || "",
        phone2: self.phone2 || (fromUser ? this.user.phone2 : manager.phone2) || "",
      };
    },
    sortedMedications() {
      if (!this.allMeds) return [];
      const reversed = [...this.allMeds].reverse();
      return reversed.sort((a, b) => {
        const dateA = a.med_startdate || a.startDate || '';
        const dateB = b.med_startdate || b.startDate || '';
        if (dateA !== dateB) {
          return dateB.localeCompare(dateA);
        }
        return 0;
      });
    },
    sortedProcedures() {
      if (!this.allProcs) return [];
      const reversed = [...this.allProcs].reverse();
      return reversed.sort((a, b) => {
        const dateA = a.diagnosis_date || a.startDate || '';
        const dateB = b.diagnosis_date || b.startDate || '';
        if (dateA !== dateB) {
          return dateB.localeCompare(dateA);
        }
        return 0;
      });
    },
    orderPharmPatientId() {
      if (!this.patient) return "";
      return String(this.patient.externId || this.patient.patient_id || "");
    },
    orderPharmAccountNumber() {
      if (!this.patient) return "";
      return String(this.patient.externId2 || this.patient.accountnumber || "");
    },
    orderPatientExternId() {
      return this.orderPharmPatientId;
    },
    // This is used to populate the diagnosis combobox with the new diagnoses that are added
    stagedDiagComboboxOptions() {
      return (this.allNewDiags || []).map((diag) => ({
        code: diag.code,
        description: diag.description,
        label: formatDiagnosisLabel(diag.code, diag.description),
      }));
    },
    // Enables save if at least one medication or procedure is added
    orderHasMedOrProc() {
      return this.newMeds.length > 0 || this.newProcs.length > 0;
    },
  },
  watch: {
    'medFormData.prn'(isPrn) {
      if (isPrn === true || isPrn === 1) {
        this.medTimeInputs = [];
      } else if (this.medFormData.frequency) {
        // If PRN is unchecked and frequency is set, regenerate times
        const timesCount = this.getTimesCountFromFrequency(this.medFormData.frequency);
        if (timesCount > 0) {
          this.medTimeInputs = this.generateDefaultTimes(timesCount);
        }
      }
    }
  },
    
  async mounted() {
    await this.getAccountType();
    this.getAllergies();
    this.loadMedications();
    this.loadProcedures();
    this.getSavedProviders();
    this.addedItem = false;
    // Only set npiSearch and related fields if account type is Provider
    const me = this.orderingActor;
    if (this.accountType === "Provider") {
      this.npiSearch = `${me.firstName} ${me.lastName}`.trim();
      this.npi = me.npi || "";
      this.npiAddress = me.address;
      this.npiPhone = me.phone1;
      this.npiFax = me.phone2;
      this.providersig = this.npiSearch;
    }
    if( this.accountType ==="Registered Nurse")
    {
      this.ifNurseAccount = true;
      //set nurse signature 
      this.nursesignature = `${me.firstName} ${me.lastName}`.trim();
    }
    if( this.accountType ==="Administrator" == this.mountAccntTypeLicense=="")
    {
      this.ifAdministrator = true; //setting Administrator Boolean so that we can set Alert and then show the Providers Drowpdown 
      
    }
    this.mT = medTimes;
    this.stampDefaultOrderDateTimeAndSignatureDates();
  },
  methods: {
    stampDefaultOrderDateTimeAndSignatureDates() {
      const now = new Date();
      const y = now.getFullYear();
      const mo = String(now.getMonth() + 1).padStart(2, "0");
      const da = String(now.getDate()).padStart(2, "0");
      const dateStr = `${y}-${mo}-${da}`;
      const hh = String(now.getHours()).padStart(2, "0");
      const mm = String(now.getMinutes()).padStart(2, "0");
      const timeStr = `${hh}:${mm}`;
      this.orderFormDate = dateStr;
      this.orderFormTime = timeStr;
      this.nursesigDate = dateStr;
      this.providersigDate = dateStr;
    },
    isMobile() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    },
    pageCount() {
      let l;
      if (this.activeSearch === "procedure") l = this.searchedProcs.length;
      if (this.activeSearch === "diagnosis") l = this.searchedDiags.length;
      return Math.ceil(l / this.size);
    },
    paginateData() {
      let start = this.pageNumber * this.size,
        end = start + this.size;
      if (this.activeSearch === "procedure")
        this.paginatedData = this.searchedProcs.slice(start, end);
      if (this.activeSearch === "diagnosis")
        this.paginatedData = this.searchedDiags.slice(start, end);
    },
    todayYYYYMMDD() {
    const d = new Date();
    const y = d.getFullYear();
    const m = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${y}-${m}-${day}`;
  },
   fillProviderInfo(prov)
  {
    if (!prov || typeof prov !== "object") return;
    console.log("Indeeex");
   // const prov = this.pastProvar[index];
   console.log("Today Date");
   console.log(this.todayYYYYMMDD());
    console.log("Checking Provider Info Passed Into FIllProviderInfo Function");
    console.log(prov);
   
    this.npiSearch = prov.firstname + " " + prov.lastname;
      this.npi = prov.npinumber;
      this.searchedNpis = null;
      this.npiAddress = prov.addr1;
      this.searchedAddresses = null;
      this.npiPhone = prov.tel;
      this.npiFax = prov.fax;
      this.npiEmail = prov.email;
      // Selecting/attaching a primary physician must NOT fill provider signature.
      // Signature is a separate attestation (provider signs later, or the ordering
      // provider fills their own name when creating a Physicians Order).
  },
    nextPage() {
      this.pageNumber++;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData();
    },
    prevPage() {
      this.pageNumber--;
      this.currPageNumber = this.pageNumber + 1;
      this.paginateData();
    },
    toPage(pageNumber) {
      this.pageNumber = pageNumber;
      this.paginateData();
    },
    async getAccountType() {
      const me = this.orderingActor;
      let content = {
        Account: {
          API_Meth: "GetAccountType",
          accountnumber: me.externId2,
          subaccountnumber: me.externId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          // console.log(res);
          if (res.data) {
            // this.filterList = res.data.providerAssignment.records;
            let accountType = res.data.providerAssignment.accounttype;

            this.accountType = accountType; // Store account type
            this.mountAccntTypeLicense = res.data.professionalLicense.license;
            console.log("Does this Provider/Nurse/Administrator Have License");
            console.log(this.mountAccntTypeLicense);
            // alert(this.accounttype);
            if (accountType == "Provider") {
              //set order type
              this.orderType = "Physicians Order";
            }
             else if(accountType =="Registered Nurse") {
              //set order type
              this.orderType = "Verbal Order";
            }
            else if(accountType =="Administrator" && (this.mountAccntTypeLicense=="" || this.mountAccntTypeLicense==null))
            {
              this.orderType="Physicians Order";
              alert("Sorry, this Administrator Accunt doesn't have an NPI - So any Order you assign to a Physician will be 'Pending' and will need a verififed Provider Signature before"+"\n"+"this order will become active.");
            }
            else{
              this.orderType = "Provider"; //just setting this as default or could change to NA
            }

          }
        });
    },
    selectNpi(npi) {
      this.loadedProvider = "";
      this.npiSearch = npi.name;
      this.npi = npi.npinumber;
      this.searchedNpis = null;
      this.searchedAddresses = npi.addresses;
        //Call Alert to See if this is were I need tdo my verfiication call 
        this.verfiyNPILookUpProvider(this.npi,this.npiSearch);
    },

    /** Mobile/desktop: picking from Assigned Providers clears any NPI lookup results. */
    onAssignedProviderChange() {
      if (!this.loadedProvider) return;
      this.fillProviderInfo(this.loadedProvider);
    },

    /** Typing for NPI lookup clears the assigned-provider selection so the two paths stay exclusive. */
    onPrimaryPhysicianLookupInput() {
      this.loadedProvider = "";
      this.showResults();
    },

    /** Same as selectNpi; named for the mobile lookup list click handler. */
    selectNpiFromLookup(npi) {
      this.selectNpi(npi);
    },

    selectProv(prov) {
      this.npiSearch = prov.firstname + " " + prov.lastname;
      this.npi = prov.npinumber;
      this.searchedNpis = null;
      this.npiAddress = prov.addr1;
      this.searchedAddresses = null;
      this.npiPhone = prov.tel;
      this.npiFax = prov.fax;
      this.npiEmail = prov.email;
    },

    selectAddr(addr) {
      this.npiAddress = addr.address ? addr.address : "";
      this.npiPhone = addr.tel ? addr.tel : "";
      this.npiFax = addr.fax ? addr.fax : "";
      this.searchedAddresses = null;
    },

    async getAllergies() {
      let content = {
        Allergy: {
          API_Meth: "GetAllergies",
          pid: this.patient.patient_id,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          let result = res.data.allergies;
          if (result) {
            result.forEach((aller) => {
              this.manualAllergies.push(aller.name);
            });
          }
        });
    },
   /*34/28/26 --Adding Verify Account UI and Send Account Creation Code */ 
 
 isSendingAccountRequest(accountrequest)
{
   switch(accountrequest)
   {
    case"Sending Request":
    {
      isacntRequestBtnDisabled.value=true;
      
      break;
    }
    case"Request Complete":
    {
      isacntRequestBtnDisabled.value =false;
      break;
    }
   }
   //now return isaccntRequestBtnDisabled
   return isacntRequestBtnDisabled.value;
},
validateEmail(email)
{
  //reg expression
  const emailRegex = /^[^\s@]+@[^\s@]+\.[A-Za-z]{2,}$/;

  console.log("Email RegExpression Vlaue");
  console.log(emailRegex.test(email));
  return emailRegex.test(email)
  //return true;
},
/** Email provider invite link; account is created only when they complete /verifyProvider. */
async sendAccountRequest(providerName,providerEmail,providerNpi)
{
  if(providerEmail.length !==0 && this.validateEmail(providerEmail)==true)
  {
    let patientid = this.patient.patient_id;
    let accountnumber = this.patient.accountnumber;
   this.accounterrorText = "Please be patient, we'r sending "+providerName +" an account creation email.";
    let content = {
  MedicationAdmin:{
    API_Meth:"SendAccountCreationEmail",
    accountnumber:accountnumber,
    patientUniqueId:patientid, // links provider to patient after registration
    provsubaccnt:patientid,
    verifyprovNPI:providerNpi,
    verifyprovName:providerName,
    verifyEmail:providerEmail
  }
 };
 axios.post(CURR_API + '/tswebhook.php',content)
   .then(response => {
    console.log(response.data);
    const actiontaken="Sending Request";
   isSendingAccountRequest(actiontaken);
    if(response.data.status =="200-Successfull" && response.data.code=="1")
      {
        //put or show the verficiation element confirm message 
        console.log("Account verified");
        console.log(response.data.message);
        this.accounterrorText="Email to "+providerName+" has been successfully sent. You will be notified once the account is created.";
        let timer = setTimeout ( () => {
          //close the modal 
          this.isAccountVerified  =false;
          this.showAccountStatTag= false;
          this.isacntRequestBtnDisabled = false;
          this.accntRequestEmail = "";//clear email field
        }, 2000);
        return ;

      }
      else if((response.data.code =="0.5" || response.data.code=="0")  && response.data.status=="200-Successfull"){
        //Account Not verfied 
        const actiontaken="Request Complete";
        isSendingAccountRequest(actiontaken);
       
        console.log("Email not sent successfully");
        console.log(response.data.message);
        
        this.accounterrorText ="Opps.. Something went wrong and the Account Creation Request Email did not send successfully."
        +"<br/>Please try again and if problem persists please contact Custom Support.";
       return;
      }
   })
   .catch(error => {
    if (axios.isAxiosError(error)) {  
           alert("Code:340 - System issue. Please contact system support");
             console.error('Error posting data:', error.response?.data || error.message);     
          //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
           } 
            else {       
              alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");   
              console.log('Unexpected error:', error);         
            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
            }    
   });
  }
  else{
   console.log(validateEmail(providerEmail));
    this.accounterrorText +="\n Need a valid email address. Please enter a valid email address.";
    this.accounterrorText = this.accounterrorText.replace(/\n/g,'<br/>');
  }
},
cancelAccountRequest()
{
  
   this.isAccountVerified = false;
   this.showAccountStatTag = false
   this.isacntRequestBtnDisabled = false;
 
},
/*3/4/26 async call to verify NPI lookup Providers|If not found lets show modal to user and send registerstration*/
async verfiyNPILookUpProvider(providerNpi,providerName)
{
 console.log("Provider that we are verifying is below");
 console.log(providerName);
  let patientid = this.patient.patient_id;
    let accountnumber = this.patient.accountnumber;
 let content = {
  MedicationAdmin:{
    API_Meth:"ProviderNPIAccountVerification",
    accountnumber:accountnumber,
    provsubaccnt:patientid,
    verifyprovNPI:providerNpi,
    verifyprovName:providerName
  }
 };
 axios.post(CURR_API + '/tswebhook.php',content)
   .then(response => {
    console.log(response.data);
    if(response.data.status =="200-Successfull" && response.data.code=="1")
      {
        //put or show the verficiation element confirm message 
        console.log("Account verified");
        console.log(response.data.message);
        this.isAccountVerified = true;
        this.showAccountStatTag = false;//close Account Not Verfied tag
        return ;

      }
      else if((response.data.code =="0.5-Partial" || response.data.code=="0")){
        //Account Not verfied 
        
       
        console.log("Account Not verified - See console log for message");
        console.log(response.data.message);
        console.log("Account Items missing for verification");
        console.log(response.data.missing);
        this.isAccountVerified = false;
        this.showAccountStatTag = true;//show Not verified tag
        this.accounterrorText =providerName +"(NPI:"+" "+providerNpi+") does not have a valid EMR Account and can not be assigned to this Order.\n"
        +"If you would like to send an account request to the provider, please confirm and do so below.\n Our System will send out a email notification using the information found below:\n"
        +"Provider Name: "+providerName +"\n"
        +"Provider NPI:" +providerNpi;
       
        this.accounterrorText = this.accounterrorText.replace(/\n/g,'<br/>');

        /*  Since the Account isn't verified were going to take 2 steps. 
        *   1 Strip pre-filled fields so validation no longer equates to true (possibly)
        *   2. Bring Up modal with Information and Alert for Account Notification
        */
        //Step 1 and strip
       
        this.npiSearch ='';
        this.npi ='';
        this.searchedNpis = null;
        this.npiAddress = '';
        this.searchedAddresses = null;
        this.npiPhone = '';
        this.npiFax ='';
        this.npiEmail = '';
         //Empty the select dropdown upon manual entry selection
         //loadedProvider.value = '';
        this.getSavedProviders();//reload `verified providers` (Internal) again 
        
        //alert("Meciation Settings Not Updated Successfully, Please try again later");
      }
   })
   .catch(error => {
    if (axios.isAxiosError(error)) {  
           alert("Code:340 - System issue. Please contact system support");
             console.error('Error posting data:', error.response?.data || error.message);     
          //  errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
           } 
            else {       
              alert("Opps, we hit an unexpectant snag, please contact your system administrator if this error presist.");   
              console.log('Unexpected error:', error);         
            //  errorMessage = 'An unexpected error occurred. Please try again.'; 
            }    
   });
},
    /*async getSavedProviders() {
      let content = {
        Provider: {
          API_Meth: "GetAllProviders",
          patientid: this.patient.patient_id,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          this.savedProviders = res.data.provider;
        });
    },*/
 async getSavedProviders() {
  console.log("CHEDK PatientID");
  console.log(this.patient);
  let patientid = this.patient.patient_id;
  let accountnumber = this.patient.accountnumber;
  try{
    let content = {
      Provider:{
      API_Meth: "GetAllProviders",
      patientid: patientid,//"709081242", //"70894333",
      accountnumber: accountnumber
      },
    };
    axios.post(CURR_API + '/tswebhook.php', content)
         .then(response => {        
          console.log('Data posted successfully:', response.data);  
         this.pastProvar = response.data.provider;
          console.log(this.pastProvar);
          this.pastProvloaded =true;
          console.log("PastProvloaded Boolean Value");
          console.log(this.pastProvloaded);
          //errorMessage = ""; // Clear any previous error messages     
         }) 
         .catch(error => {       
           if (axios.isAxiosError(error)) {  
             console.error('Error posting data:', error.response?.data || error.message);     
           // errorMessage = error.response?.data?.message || 'An error occurred while posting data.';  
           } 
            else {          
              console.log('Unexpected error:', error);         
             // errorMessage = 'An unexpected error occurred. Please try again.'; 
            }    
            });   
  }
  catch(error)
  {
    console.error("Error Posting to Past Provider enpoint:",error);
  }
 },
    // async loadDiagAndProc() {
    //   let content = {
    //     Diagnosis: {
    //       API_Meth: "PopulateDiagGrid",
    //       patientID: this.patient.patient_id,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       if (res.data.gridhtml) {
    //         this.allDiags = res.data.data.filter(
    //           (diag) => diag.diagnosis_type === "Diagnosis"
    //         );
    //         this.allProcs = res.data.data.filter(
    //           (proc) => proc.diagnosis_type === "Procedure"
    //         );
    //       } else {
    //         this.allDiags = null;
    //         this.allProcs = null;
    //       }
    //     });
    // },

    async loadMedications() {
      // Use PopulateMedGrid to get medications from the medications table (same as CurrentMed)
      const patientId = this.patient.externId || this.patient.patient_id;
      let content = {
        MedGrid: {
          API_Meth: "PopulateMedGrid",
          pid: patientId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml && res.data.data) {
            this.allMeds = res.data.data;
          } else {
            this.allMeds = null;
          }
        });
    },

    async loadProcedures() {
      // Use PopulateDiagGrid to get procedures from orders_diagnosis table (same as CurrentProc)
      const patientId = this.patient.externId || this.patient.patient_id;
      let content = {
        Diagnosis: {
          API_Meth: "PopulateDiagGrid",
          patientID: patientId,
        },
      };
      await axios
        .post(CURR_API + "/tswebhook.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.gridhtml && res.data.data) {
            // Filter for procedures only (same as CurrentProc)
            this.allProcs = res.data.data.filter(
              (proc) => proc.diagnosis_type === "Procedure"
            );
          } else {
            this.allProcs = null;
          }
        });
    },

    // async loadMedications() {
    //   let content = {
    //     MedGrid: {
    //       API_Meth: "PopulateMedGrid",
    //       pid: this.patient.patient_id,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       if (res.data.gridhtml) {
    //         this.allMeds = res.data.data;
    //       } else {
    //         this.allMeds = null;
    //       }
    //     });
    // },

    // async saveOrder() {
    //   let form = document.getElementById("orderform" + this.patient.patient_id);
    //   let content = {
    //     OrderTemp: {
    //       API_Meth: "InsertOrder",
    //       ordernumber: this.orderNum,
    //       patientID: this.patient.patient_id,
    //       orderdate: form.elements["date"].value,
    //       ordertime: form.elements["time"].value,
    //       ordertype: form.elements["ordertype"].value,
    //       abndelivery: form.elements["abn"].value,
    //       ordReadback: form.elements["phyAgent"].value,
    //       primphysician: this.npiSearch,
    //       secphysician: form.elements["secphysician"].value,
    //       email: this.npiEmail,
    //       npinumber: this.npi,
    //       address: this.npiAddress,
    //       phone: this.npiPhone,
    //       fax: this.npiFax,
    //       sendtophysicans: this.sendtophys,
    //       woundcare: this.woundcare,
    //       verbalorder: "",
    //       verbalStartdt: "1900-01-01",
    //       verbalEnddt: "12:00",
    //       description: this.message,
    //       status:
    //         form.elements["ordertype"].value === "Physicians Order"
    //           ? "Active"
    //           : "Pending",
    //       hasmed: false,
    //       hasdiag: false,
    //       writer: this.user.firstName + " " + this.user.lastName,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       if (res.data.result == "Inserted") {
    //         let msg =
    //           "Order number " + this.orderNum + " has been successfully submitted.";
    //         this.addedItem = false;
    //         alert(msg);
    //         this.closeOrder();
    //       } else {
    //         alert(res.data.data);
    //       }
    //     });
    // },

    /**
     * Stage a diagnosis on this order (allNewDiags → InsertNewOrder → Current Diagnosis).
     * @param {string} source - From DiagnosisCombobox: "patient" (already on chart) or "search" (ICD lookup).
     *   Patient picks are not re-staged; backend also skips chart duplicates.
     */
    addNewDiag(code, description, startDt, source) {
      // Already on the patient's Current Diagnosis list — nothing new to insert.
      if (source === "patient") return;

      // Normalize free-text / combobox values into code + "CODE - description" label.
      const parsed = parseDiagnosisLabel(
        description || formatDiagnosisLabel(code, description)
      );
      const finalCode = (code || parsed.code || "").trim();
      const finalDescription = (
        description ||
        parsed.label ||
        parsed.description ||
        ""
      ).trim();
      if (!finalCode && !finalDescription) return;

      // Skip if this order already staged the same ICD (by code or description).
      const norm = (value) => (value || "").trim().toLowerCase();
      const isDuplicate = (this.allNewDiags || []).some((existing) => {
        const existingCode = norm(existing.code);
        const existingDesc = norm(existing.description);
        return (
          (finalCode && existingCode === norm(finalCode)) ||
          (finalDescription && existingDesc === norm(finalDescription))
        );
      });
      if (isDuplicate) return;

      let newDiag = {
        pid: this.patient.patient_id,
        accountId: this.patient.accountnumber,
        code: finalCode,
        description: finalDescription,
        shorthand: "",
        startDate: startDt,
        status: "Active",
        assignerName: `${this.orderingActor.firstName} ${this.orderingActor.lastName}`.trim(),
        assignerId: this.orderingActor.externId,
      };
      this.allNewDiags.push(newDiag);
    },

    // Populate the diagnosis combobox with the new diagnoses that are added
    onOrderDiagnosisSelect({ code, description, source }) {
      this.diagSearchCode = code;
      this.diagSearchDescrip = formatDiagnosisLabel(code, description);
      this.diagSelectSource = source || null;
    },

    addNewProc() {
      let form = document.getElementById("procmodal" + this.patient.patient_id);
      let newProc = {
        pid: this.patient.patient_id,
        accountId: this.patient.accountnumber,
        code: this.officialProc,
        shorthand: form.elements["procCode"].value,
        instructions: form.elements["instruction"].value,
        startDate: form.elements["startDt"].value || null,
        endDate: form.elements["endDt"].value || null,
        status: "Pending",
        assignerName: `${this.orderingActor.firstName} ${this.orderingActor.lastName}`.trim(),
        assignerId: this.orderingActor.externId,
        diagCode: this.diagSearchCode,
        diagDescription: this.diagSearchDescrip,
      };
      this.newProcs.push(newProc);
      this.addNewDiag(
        this.diagSearchCode,
        this.diagSearchDescrip,
        form.elements["startDt"].value,
        this.diagSelectSource
      );
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.diagSelectSource = null;
      this.procSearchDescrip = "";
      this.officialProc = "";
      form.reset();
      if (!this.isMobile()) form.style.display = "none";
      this.mobileSubModal = null;
    },

    // Saved med to db while also adding the diagnosis to the diagnosis combobox
    // Times are saved to the database as a string of comma separated times
    handleMobileOrderMedSave(formData, timeInputs, diagnosisSource) {
      const slotedtimesArray = (timeInputs || [])
        .filter((t) => t && t.trim() !== "")
        .map((t) => ({
          time: t.trim(),
          status: "pending",
          dosage: parseInt(formData.dosage, 10) || 1,
        }));

      const administrationTimes =
        timeInputs && timeInputs.length > 0
          ? timeInputs.filter((t) => t).join(", ")
          : formData.prn
            ? "As needed"
            : "";

      const todayDate = new Date().toISOString().split("T")[0];
      const pn = (formData.pharmacyName || "").trim();
      const pnp = (formData.pharmacyNpi || "").trim();
      const pa = (formData.pharmacyAddress || "").trim();
      if (!pn || !pnp || !pa) {
        alert(
          "Pharmacy name, NPI, and address are required for each new medication so the order can be linked to a pharmacy. Use the Pharmacy Information tab to search or enter the pharmacy."
        );
        return;
      }

      const parsedDiag = parseDiagnosisLabel(formData.diagnosis || "");
      const diagCode = (parsedDiag.code || formData.diagnosis || "").trim();
      const diagDescription = formData.diagdescription
        ? formatDiagnosisLabel(diagCode, formData.diagdescription)
        : parsedDiag.label || parsedDiag.description || formData.diagnosis || "";

      const newMed = {
        pid: this.patient.patient_id,
        accountId: this.patient.accountnumber,
        medName: formData.medicationName,
        medShorthand: formData.medicationName,
        quantity: formData.quantity || formData.dosage || "",
        dosage: formData.dosage || "",
        frequency: formData.frequency,
        duration: formData.duration || "",
        prn: formData.prn ? 1 : 0,
        route: formData.route,
        altRoute: "",
        instructions: formData.instructions || "",
        startDate: formData.startDate || todayDate,
        endDate: formData.endDate || "",
        status: "Pending",
        assignerName: `${this.orderingActor.firstName} ${this.orderingActor.lastName}`.trim(),
        assignerId: this.orderingActor.externId,
        diagCode,
        diagDescription,
        prepour: formData.prepour ? 1 : 0,
        administration: formData.administration ? 1 : 0,
        nebulizer: formData.nebulizer ? 1 : 0,
        unitType: formData.unitType || "",
        dosageForm: formData.unitType || "",
        ndcnumber: formData.ndcnumber || "",
        rxnorns: formData.rxnorns || "",
        newMedication: formData.newMedication ? 1 : 0,
        refills: 0,
        administrationTimes,
        slotedtimes: slotedtimesArray,
        fluidType: formData.fluidType || "",
        totalVolume: formData.totalVolume || "",
        totalVolumeUnit: formData.totalVolumeUnit || "ml",
        rate: formData.rate || "",
        howLong: formData.howLong || "",
        startTime: formData.startTime || "",
        endTime: formData.endTime || "",
        via: formData.via || "",
        pharmacyName: pn,
        pharmacyNpi: pnp,
        pharmacyAddress: pa,
        pharmacyPhone: (formData.pharmacyOffice || "").trim(),
        pharmacyCell: (formData.pharmacyCell || "").trim(),
        pharmacyEmail: (formData.pharmacyEmail || "").trim(),
        pharmacyDea: (formData.pharmacyDea || "").trim(),
      };
      this.newMeds.push(newMed);
      if (diagCode || diagDescription) {
        this.addNewDiag(diagCode, diagDescription, newMed.startDate, diagnosisSource);
      }
      this.closeMed();
    },

    // saveDiag function is used to save the diagnosis information to the database
    saveDiag() {
      const form = document.getElementById("diagnosismodal" + this.patient.patient_id);
      if (!form) return;

      const date = form.elements["date"].value;
      this.addNewDiag(
        this.diagSearchCode,
        this.diagSearchDescrip,
        date,
        this.diagSelectSource
      );
      if (!this.allDiags) this.allDiags = [];
      this.allDiags.push({
        diagnosis_code: this.diagSearchDescrip,
        diagnosis_date: date,
      });
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.diagSelectSource = null;
      this.searchedDiags = [];
      form.reset();
      if (!this.isMobile()) form.style.display = "none";
      this.mobileSubModal = null;
    },

    saveProc() {
      this.addNewProc();
    },

    addNewMed() {
      // Convert timeInputs to slotedtimes format for medicationlog
      const slotedtimesArray = this.medTimeInputs
        .filter(t => t && t.trim() !== '')
        .map(t => ({
          time: t.trim(),
          status: 'pending',
          dosage: parseInt(this.medFormData.dosage, 10) || 1
        }));

      // Build administration times string
      const administrationTimes = this.medTimeInputs.length > 0 
        ? this.medTimeInputs.filter(t => t).join(', ') 
        : (this.medFormData.prn ? 'As needed' : '');

      // Get today's date in YYYY-MM-DD format
      const today = new Date();
      const todayDate = today.toISOString().split('T')[0];

      const pn = (this.medFormData.pharmacyName || "").trim();
      const pnp = (this.medFormData.pharmacyNpi || "").trim();
      const pa = (this.medFormData.pharmacyAddress || "").trim();
      if (!pn || !pnp || !pa) {
        alert(
          "Pharmacy name, NPI, and address are required for each new medication so the order can be linked to a pharmacy. Use the Pharmacy Information tab to search or enter the pharmacy."
        );
        this.orderMedActiveTab = "pharmacyInfo";
        return;
      }

      let newMed = {
        pid: this.patient.patient_id,
        accountId: this.patient.accountnumber,
        medName: this.medFormData.medicationName,
        medShorthand: this.medFormData.medicationName,
        quantity: this.medFormData.quantity || this.medFormData.dosage || "",
        dosage: this.medFormData.dosage || "",
        frequency: this.medFormData.frequency,
        duration: this.medFormData.duration || "",
        prn: this.medFormData.prn ? 1 : 0,
        route: this.medFormData.route,
        altRoute: "",
        instructions: "", // Instructions field removed from form
        startDate: todayDate, // Auto-set to today's date
        status: "Pending",
        assignerName: `${this.orderingActor.firstName} ${this.orderingActor.lastName}`.trim(),
        assignerId: this.orderingActor.externId,
        diagCode: this.diagSearchCode,
        diagDescription: this.diagSearchDescrip,
        prepour: this.medFormData.prepour ? 1 : 0,
        administration: this.medFormData.administration ? 1 : 0,
        nebulizer: this.medFormData.nebulizer ? 1 : 0,
        // New fields
        unitType: this.medFormData.unitType || "",
        dosageForm: this.medFormData.unitType || "", // Same as unitType
        ndcnumber: this.medFormData.ndcnumber || "",
        rxnorns: this.medFormData.rxnorns || "",
        newMedication: this.medFormData.newMedication ? 1 : 0,
        refills: 0, // Refills field removed from form
        // Administration times
        administrationTimes: administrationTimes,
        slotedtimes: slotedtimesArray,
        // IV fields
        fluidType: this.medFormData.fluidType || "",
        totalVolume: this.medFormData.totalVolume || "",
        totalVolumeUnit: this.medFormData.totalVolumeUnit || "ml",
        rate: this.medFormData.rate || "",
        howLong: this.medFormData.howLong || "",
        startTime: this.medFormData.startTime || "",
        endTime: this.medFormData.endTime || "",
        via: this.medFormData.via || "",
        pharmacyName: pn,
        pharmacyNpi: pnp,
        pharmacyAddress: pa,
        pharmacyPhone: (this.medFormData.pharmacyOffice || "").trim(),
        pharmacyCell: (this.medFormData.pharmacyCell || "").trim(),
        pharmacyEmail: (this.medFormData.pharmacyEmail || "").trim(),
        pharmacyDea: (this.medFormData.pharmacyDea || "").trim()
      };
      this.newMeds.push(newMed);
      this.addNewDiag(
        this.diagSearchCode,
        this.diagSearchDescrip,
        todayDate,
        this.diagSelectSource
      );
      
      // Reset form
      this.resetMedForm();
      // close the medication modal
      this.mobileSubModal = null;
    },

    async saveNewOrder() {
      // Another check to ensure at least one medication or procedure is added
      if (this.newMeds.length === 0 && this.newProcs.length === 0) {
        return;
      }
      let form = document.getElementById("orderform" + this.patient.patient_id);
      const orderType = form.elements["ordertype"].value;
      const isNurseOrVerbal =
        orderType === "Nurses Order" || orderType === "Verbal Order";
      // Nurse/verbal orders: nurse signs; primary physician is contact info only —
      // never treat the attached provider name as a provider signature.
      const nurseSignature = isNurseOrVerbal ? this.nursesignature : "";
      const nurseSigDate = isNurseOrVerbal ? this.nursesigDate : null;
      const provSignature = isNurseOrVerbal ? "" : this.providersig;
      const provSigDate = isNurseOrVerbal ? null : this.providersigDate;
      let newOrder = {
        API_Meth: "InsertNewOrder",
        pid: this.patient.patient_id,
        accountId: this.patient.accountnumber,
        creatorName: `${this.orderingActor.firstName} ${this.orderingActor.lastName}`.trim(),
        creatorId: this.orderingActor.externId,
        orderDate: form.elements["date"].value,
        orderTime: form.elements["time"].value,
        orderType,
        abnDelivery: form.elements["abn"].value,
        readOrderBack: form.elements["phyAgent"].value,
        primaryPhysician: this.npiSearch,
        // Taxonomy exists on desktop only; mobile omits that field.
        primaryTaxonomy: form.elements["taxonomy"]?.value ?? "",
        npi: this.npi,
        email: this.npiEmail,
        address: this.npiAddress,
        phone: this.npiPhone,
        fax: this.npiFax,
        description: this.message,
        status:
          orderType == "Physicians Order"
            ? "Active-Pending"
            : "Pending",
        newMeds: JSON.stringify(this.newMeds),
        newProcs: JSON.stringify(this.newProcs),
        newDiags: JSON.stringify(this.allNewDiags),
        nurseSignature,
        nurseSigDate,
        provSignature,
        provSigDate,
        accountType:this.accountType
      };
      console.log(newOrder);
      await axios
        .post(CURR_API + "/tswebhook.php", newOrder, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          console.log(res);
          if (res.status == 200) {
            let msg = "Order has been successfully submitted.";
            alert(msg);
            this.newProcs = [];
            this.newMeds = [];
            this.allNewDiags = [];
            this.closeOrder();
          } else {
            alert("Error with submitting order.");
          }
        });
    },

    // async saveMed() {
    //   let form = document.getElementById("dosesform" + this.patient.patient_id);
    //   let content = {
    //     MedicationInsert: {
    //       API_Meth: "InsertMedication",
    //       patientID: this.patient.patient_id,
    //       ordernumber: this.orderNum,
    //       medname: this.officialMed,
    //       shorthand: this.medicationSearchDescrip,
    //       doseamount: form.elements["amount"].value,
    //       doseUOM: "", //form.elements['UOM'].value,
    //       frequency: form.elements["freq"].value,
    //       diagcode: form.elements["reason"].value,
    //       medRoute: form.elements["route"].value,
    //       altroute: "",
    //       instruction: form.elements["instructions"].value,
    //       medstrtdt: form.elements["startDate"].value
    //         ? form.elements["startDate"].value
    //         : null,
    //       medenddt: form.elements["endDate"].value
    //         ? form.elements["endDate"].value
    //         : null,
    //       changetype: form.elements["neworchange"].value,
    //       durgclassification: form.elements["drug"].value,
    //       prn: document.getElementById("prncheckbox" + this.patient.patient_id).checked,
    //       directionuse: "",
    //       additionalsettings: "",
    //       status: "Pending",
    //       writer: this.user.firstName + " " + this.user.lastName,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       if (res.data.sqlresult && res.data.sqlresult == "Inserted") {
    //         this.medicationSearchCode = "";
    //         this.medicationSearchDescrip = "";
    //         this.diagSearchCode = "";
    //         this.diagSearchDescrip = "";
    //         this.loadMedications();
    //         alert("Medication successfully added");
    //         this.addedItem = true;
    //         document.getElementById("mediationmodal" + this.patient.patient_id).style.display =
    //           "none";
    //         $("#mediationmodal" + this.patient.patient_id).css("display", "none");
    //         // $(".modalbottom form").css("display","none");
    //         // $(".mednamesec").css("display","none");
    //         form.reset();
    //       } else {
    //         alert(
    //           "Error with medication insertion. Try again or contact an administrator."
    //         );
    //       }
    //     });
    // },

    // async saveProc() {
    //   let form = document.getElementById("procmodal" + this.patient.patient_id);
    //   let content = {
    //     Diagnosis: {
    //       API_Meth: "InsertDiagnosis",
    //       ordernumber: this.orderNum,
    //       diagnosis_type: "Procedure",
    //       onset_exacerbation: "",
    //       diagnosisDate: form.elements["startDt"].value
    //         ? form.elements["startDt"].value
    //         : null,
    //       endDate: form.elements["endDt"].value ? form.elements["endDt"].value : null,
    //       diagControlRating: "",
    //       diagcode: form.elements["icdCode"].value,
    //       proccode: this.officialProc,
    //       procShorthand: form.elements["procCode"].value,
    //       pid: this.patient.patient_id,
    //       status: "Pending",
    //       instruction: form.elements["instruction"].value,
    //       writer: this.user.firstName + " " + this.user.lastName,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       if (res.data.result && res.data.result == "Inserted") {
    //         this.diagSearchCode = "";
    //         this.diagSearchDescrip = "";
    //         this.procSearchDescrip = "";
    //         this.officialProc = "";
    //         this.loadDiagAndProc();
    //         this.addedItem = true;
    //         alert("Procedure successfully added");
    //         form.style.display = "none";
    //         form.reset();
    //       } else {
    //         alert(
    //           "Error with procedure insertion. Try again or contact an administrator."
    //         );
    //       }
    //     });
    // },

    // async saveDiag() {
    //   let form = document.getElementById("diagnosismodal" + this.patient.patient_id);
    //   let content = {
    //     Diagnosis: {
    //       API_Meth: "InsertDiagnosis",
    //       ordernumber: this.orderNum,
    //       diagnosis_type: "Diagnosis",
    //       onset_exacerbation: "",
    //       diagnosisDate: form.elements["date"].value ? form.elements["date"].value : null,
    //       endDate: null,
    //       diagControlRating: "",
    //       diagcode: form.elements["icdCode"].value,
    //       proccode: "",
    //       pid: this.patient.patient_id,
    //       status: "Pending",
    //       instruction: "",
    //       writer: this.user.firstName + " " + this.user.lastName,
    //     },
    //   };
    //   await axios
    //     .post(CURR_API + "/tswebhook.php", content, {
    //       headers: { "Content-Type": "application/json;" },
    //     })
    //     .then((res) => {
    //       if (res.data.result && res.data.result == "Inserted") {
    //         this.diagSearchCode = "";
    //         this.diagSearchDescrip = "";
    //         this.loadDiagAndProc();
    //         this.addedItem = true;
    //         alert("Diagnosis successfully added");
    //         this.closeDiag();
    //       } else {
    //         alert(
    //           "Error with diagnosis insertion. Try again or contact an administrator."
    //         );
    //       }
    //     });
    // },

    async showResults() {
      let content = {
        methname: "GetAllInfo",
        primphysician: this.npiSearch,
      };
      // this.showPreloader()
      await axios
        .post(CURR_API + "/NPILookup.php", content, {
          headers: { "Content-Type": "application/json;" },
        })
        .then((res) => {
          if (res.data.results && res.data.results == "No Results Found") {
            this.searchedNpis = null;
          } else this.searchedNpis = res.data;
        });
      // this.stopPreloader()
    },
    async showMedSearch() {
      if (this.medicationSearchDescrip == "") {
        this.searchedMeds = [];
        return;
      }
      let posturl =
        "https://rxnav.nlm.nih.gov/REST/drugs.json?name=" + this.medicationSearchDescrip;
      await axios.get(posturl).then((res) => {
        if (res.data.drugGroup.conceptGroup) {
          for (let tty of res.data.drugGroup.conceptGroup) {
            if (tty.conceptProperties) {
              this.searchedMeds = this.searchedMeds.concat(tty.conceptProperties);
            }
          }
        } else {
          this.searchedMeds = [];
        }
      });
    },
    async showProcSearch() {
      this.activeSearch = "procedure";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];
      if (this.procSearchDescrip == "") {
        this.searchedProcs = [];
        this.searchDiags = [];
        this.paginatedData = [];
        return;
      }
      if (!isNaN(this.procSearchDescrip)) {
        let content = {
          Diagnosis: {
            API_Meth: "SearchProcedure-Code",
            searchterms: this.procSearchDescrip,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result && res.data.result != "No Data Found") {
              this.searchedProcs = res.data.result;
            } else {
              this.searchedProcs = [];
            }
          });
      } else {
        let content = {
          Diagnosis: {
            API_Meth: "SearchProcedure-Description",
            description: this.procSearchDescrip,
          },
        };
        await axios
          .post(CURR_API + "/tswebhook.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.count) {
              if (res.data.result.msg) {
                alert("Error:" + res.data.result.msg);
              } else {
                this.searchedProcs = res.data.result;
                this.currPageNumber = 1;
                this.pageNumber = 0;
                this.paginateData();
              }
            } else {
              this.searchedProcs = [];
              this.paginatedData = [];
            }
          });
      }
    },
    async showDiagSearch() {
      this.activeSearch = "diagnosis";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.paginatedData = [];

      if (this.diagSearchDescrip == "") {
        this.searchedProcs = [];
        this.searchedDiags = [];
        this.paginatedData = [];
        return;
      }
      if (this.icdSearch) {
        let content = {
          action: "Search",
          searchTerm: this.diagSearchDescrip,
          ICDCode: "",
          ICDReleaseUrl: "",
        };
        await axios
          .post(CURR_API + "/icd_calls.php", content, {
            headers: { "Content-Type": "application/json;" },
          })
          .then((res) => {
            if (res.data.result == 0) {
              this.searchedDiags = [];
            } else {
              this.searchedDiags = res.data.actualResults;
              this.currPageNumber = 1;
              this.pageNumber = 0;
              this.paginateData();
            }
          });
      }
      // else {
      //   let content = {
      //     "action": "CodeLookUp",
      //     "searchTerm": "",
      //     "ICDCode":
      //   }
      // }
    },
    cancelOrder() {
      if (this.newProcs.length > 0 || this.newMeds.length > 0) {
        if (
          !confirm(
            "Are you sure you want to cancel any new medications/procedures you've added?"
          )
        ) {
          return;
        }
        this.newProcs = [];
        this.newMeds = [];
        this.allNewDiags = [];
      }
      this.closeOrder();
    },
    // async cancelOrder() {
    //   if (this.addedItem) {
    //     if (
    //       confirm(
    //         "Are you sure you want to cancel this order? This will delete all procedures, medications, and diagnoses associated with this order after you first opened it."
    //       )
    //     ) {
    //       let content = {
    //         Order: {
    //           API_Meth: "ClearPending",
    //           ordnum: this.orderNum,
    //           status: "Pending",
    //         },
    //       };
    //       await axios
    //         .post(CURR_API + "/tswebhook.php", content, {
    //           headers: { "Content-Type": "application/json;" },
    //         })
    //         .then((res) => {
    //           if (res.data.recRemoved) {
    //             if (res.data.recRemoved === "Pending Medication and Diagnosis Deleted") {
    //               alert("All pending items attached to this order have been deleted.");
    //               this.closeOrder();
    //             } else {
    //               alert("Error deleting pending items attached to this order.");
    //               this.closeOrder();
    //             }
    //           } else {
    //             alert("Error deleting pending items attached to this order.");
    //             this.closeOrder();
    //           }
    //           this.loadMedications();
    //           this.loadDiagAndProc();
    //           this.addedItem = false;
    //         });
    //     }
    //   } else {
    //     this.closeOrder();
    //   }
    // },
    clickDiag(diag) {
      this.diagSearchCode = diag.code;
      this.diagSearchDescrip = diag.code + " - " + diag.description;
      this.searchedDiags = [];
    },
    clickProc(proc) {
      this.officialProc = proc.code + " - " + proc.description;
      this.searchedProcs = [];
      this.paginatedData = [];
    },
    clickMed(med) {
      this.medicationSearchCode = med.rxcui;
      this.officialMed = med.name;
      this.searchedMeds = [];
      // $("#medicationName").html(this.medicationSearchCode + ' - ' + this.medicationSearchDescrip)
      // $("#medsearchbox"+this.patient.patient_id).css("display","none");
      // $(".modalbottom form").css("display","flex");
      // $(".mednamesec").css("display","block");
      // $("#cancelbtn"+this.patient.patient_id).css("display", "none")
    },
    showReAddMed(med) {
      this.showAddMed();
      console.log("SHow ME THE MEDOBJECT MONEY");
      console.log(med);
      // Use field names from medications table (matching CurrentMed)
      this.medicationSearchDescrip = med.medname || med.medName || '';
      this.medFormData.medicationName = med.medname || med.medName;
      this.diagSearchDescrip = med.diagnose_code || med.description || '';
      const form = document.querySelector("#dosesform" + this.patient.patient_id);
      if (form) {
        this.medFormData.route  = med.route;
        this.medFormData.frequency = med.med_frequency;
        this.medFormData.quantity = med.available;
        this.medFormData.dosage =med.med_amount;
        this.medFormData.ndcnumber = med.ndcnumber;
        this.medFormData.rxnorns = med.rxnorns;
        if(med.prn="0")
        {
          this.medFormData.prn = false;
        }
        else{
          this.medFormData.prn = true;
        }
        if(med.additional_settings=="Administered")
        {
          this.medFormData.administration = true;
        }
        else{
          this.medFormData.administration = false;
        }
        const routeField = form.querySelector("#medRoute");
        if (routeField) routeField.value = med.route || '';
        const amountField = form.querySelector("#amount");
        if (amountField) amountField.value = med.med_amount || med.quantity || '';
        const startDateField = form.querySelector("#medStartdate");
        if (startDateField) startDateField.value = med.med_startdate || med.startDate || '';
        const freqField = form.querySelector("#freqselect");
        if (freqField) freqField.value = med.med_frequency || med.frequency || '';
        const instructionsField = form.querySelector("#medInstructions");
        if (instructionsField) instructionsField.value = med.instruction || med.instructions || '';
        const endDateField = form.querySelector("#Medenddate");
        if (endDateField) endDateField.value = med.med_enddate || med.endDate || '';
      }
    },
    showAddMed() {
      this.resetMedForm();
      if (this.isMobile()) {
        this.mobileSubModal = "med";
        return;
      }
      $("#mediationmodal" + this.patient.patient_id).css("display", "flex");
      $("#dosesform" + this.patient.patient_id).css("display", "block");
    },
    showReAddProc(proc) {
      this.showAddProc();
      let form = document.getElementById("procmodal" + this.patient.patient_id);
      this.diagSearchDescrip = proc.diagnosis_code;
      this.procSearchDescrip = proc.procedure_code;
      document.querySelector(
        "#procmodal" + this.patient.patient_id + " #diagnosisEndDate"
      ).value = proc.end_date;
      document.querySelector(
        "#procmodal" + this.patient.patient_id + " #diagnosisStartDate"
      ).value = proc.diagnosis_date;
      document.querySelector(
        "#procmodal" + this.patient.patient_id + " #instruction"
      ).value = proc.instruction;
    },
    showAddProc() {
      if (this.isMobile()) {
        this.mobileSubModal = "proc";
        return;
      }
      const form = document.getElementById("procmodal" + this.patient.patient_id);
      if (form) form.style.display = "block";
    },
    closeDiag() {
      let form = document.getElementById("diagnosismodal" + this.patient.patient_id);
      if (form) {
        form.reset();
        if (!this.isMobile()) form.style.display = "none";
      }
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.diagSelectSource = null;
      this.searchedDiags = [];
      this.mobileSubModal = null;
    },
    closeProc() {
      let form = document.getElementById("procmodal" + this.patient.patient_id);
      if (form) {
        form.reset();
        if (!this.isMobile()) form.style.display = "none";
      }
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.diagSelectSource = null;
      this.procSearchDescrip = "";
      this.officialProc = "";
      this.searchedProcs = [];
      this.searchedDiags = [];
      this.mobileSubModal = null;
    },
    closeFirstMed() {
      let modal = document.getElementById("mediationmodal" + this.patient.patient_id);
      modal.style.display = "none";
      this.medicationSearchCode = "";
      this.medicationSearchDescrip = "";
    },
    // New medication form methods
    resetMedForm() {
      this.medFormData = {
        medicationName: "",
        ndcnumber: "",
        rxnorns: "",
        diagnosis: "",
        diagdescription: "",
        dosage: "",
        unitType: "",
        frequency: "",
        route: "Oral",
        prn: false,
        newMedication: false,
        quantity: 0,
        duration: "",
        refills: 0,
        instructions: "",
        startDate: "",
        endDate: "",
        administration: false,
        prepour: false,
        nebulizer: false,
        fluidType: "",
        totalVolume: "",
        totalVolumeUnit: "ml",
        rate: "",
        howLong: "",
        startTime: "",
        endTime: "",
        via: "",
        pharmacyName: "",
        pharmacyDea: "",
        pharmacyNpi: "",
        pharmacyAddress: "",
        pharmacyOffice: "",
        pharmacyCell: "",
        pharmacyEmail: ""
      };
      this.medTimeInputs = [];
      this.medSearchResults = [];
      this.showMedSuggestions = false;
      this.showIvForm = false;
      this.medicationSearchCode = "";
      this.medicationSearchDescrip = "";
      this.diagSearchCode = "";
      this.diagSearchDescrip = "";
      this.diagSelectSource = null;
      this.officialMed = "";
      this.orderMedActiveTab = "medInfo";
    },

    handleFrequencyChange() {
      if (this.medFormData.prn) {
        this.medTimeInputs = [];
        return;
      }
      if (!this.medFormData.frequency) {
        this.medTimeInputs = [];
        return;
      }
      const timesCount = this.getTimesCountFromFrequency(this.medFormData.frequency);
      if (timesCount > 0) {
        this.medTimeInputs = this.generateDefaultTimes(timesCount);
      } else {
        this.medTimeInputs = [];
      }
    },

    getTimesCountFromFrequency(frequency) {
      const dailyMatch = frequency.match(/(\d+)\s*times?\s*daily/);
      if (dailyMatch) {
        return parseInt(dailyMatch[1], 10);
      }
      const hoursMatch = frequency.match(/every\s*(\d+)\s*hours?/);
      if (hoursMatch) {
        const hours = parseInt(hoursMatch[1], 10);
        return Math.floor(24 / hours);
      }
      switch (frequency.toLowerCase()) {
        case 'every hour': return 24;
        case 'daily': return 1;
        case 'at bedtime': return 1;
        case 'every 24 hours': return 1;
        case 'every other day': return 4;
        case 'every monday, wednesday, friday, sunday': return 4;
        case 'every tuesday, thursday, saturday': return 3;
        case '1 time daily': return 1;
        case '2 time daily': return 2;
        case '3 time daily': return 3;
        case 'twice daily': return 2;
        case 'as needed': return 0;
        case 'as directed': return 1;
        case 'as one dose': return 1;
        case 'one time dose': return 1;
        default: return 1;
      }
    },

    generateDefaultTimes(count) {
      if (count <= 0) return [];
      if (count === 1) return ['08:00'];
      if (count === 2) return ['08:00', '20:00'];
      if (count === 3) return ['08:00', '14:00', '20:00'];
      if (count === 4) return ['08:00', '12:00', '18:00', '22:00'];
      
      // For more than 4 times, distribute evenly across 24 hours
      const times = [];
      const interval = 24 / count;
      for (let i = 0; i < count; i++) {
        const hour = Math.floor(i * interval);
        const minutes = Math.round((i * interval - hour) * 60);
        const timeStr = `${String(hour).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        times.push(timeStr);
      }
      return times;
    },

    checkMedRouteSelection(route) {
      if (route === "IV (Intravenous)") {
        this.showIvForm = true;
      } else {
        this.showIvForm = false;
      }
    },

    async debouncedMedFetch() {
      clearTimeout(this.medDebounceTimer);
      this.medDebounceTimer = setTimeout(() => {
        this.fetchMedSuggestions();
      }, 300);
    },

    async fetchMedSuggestions() {
      const q = this.medFormData.medicationName.trim();
      if (!q) {
        this.medSearchResults = [];
        this.showMedSuggestions = false;
        return;
      }

      try {
        // 1) brand_name search
        this.medSearchMode = 'brand';
        let resp = await axios.get(
          `https://api.fda.gov/drug/ndc.json?search=brand_name:${encodeURIComponent(q)}*&limit=100`
        );
        let data = resp.data;

        // 2) fallback to generic_name if no brand results
        if (!Array.isArray(data.results) || data.results.length === 0) {
          this.medSearchMode = 'generic';
          resp = await axios.get(
            `https://api.fda.gov/drug/ndc.json?search=generic_name:${encodeURIComponent(q)}*&limit=100`
          );
          data = resp.data;
        }

        // 3) Expand each product's packaging entries into separate results
        const allResults = Array.isArray(data.results) ? data.results : [];
        const expandedResults = [];
        
        for (const product of allResults) {
          // Only process products with valid packaging arrays
          if (product.packaging && Array.isArray(product.packaging) && product.packaging.length > 0) {
            // Create a separate result entry for each packaging entry
            for (const pkg of product.packaging) {
              // Only include packaging entries with valid NDCs
              if (pkg.package_ndc && pkg.package_ndc.trim() !== '') {
                expandedResults.push({
                  ...product,
                  selectedPackaging: pkg
                });
              }
            }
          }
        }
        
        this.medSearchResults = expandedResults;
        this.showMedSuggestions = this.medSearchResults.length > 0;
      } catch (err) {
        console.error('FDA lookup error', err);
        this.medSearchResults = [];
        this.showMedSuggestions = false;
      }
    },

    formatMedIngredients(ingredients) {
      if (!ingredients || !Array.isArray(ingredients)) return '';
      return ingredients.map(ing => `${ing.name} ${ing.strength || ''}`).join(', ');
    },

    selectMedResult(item) {
      // Determine display name (brand vs generic)
      const baseName = this.medSearchMode === 'brand' && item.brand_name
        ? item.brand_name
        : item.generic_name;

      // Format ingredients string
      const ingStr = this.formatMedIngredients(item.active_ingredients || []);
      const displayName = ingStr
        ? `${baseName} (${ingStr})`
        : baseName;

      // Populate the Medication Name input
      this.medFormData.medicationName = displayName;

      // NDC - use the specific packaging entry's NDC that was selected
      if (item.selectedPackaging?.package_ndc) {
        this.medFormData.ndcnumber = item.selectedPackaging.package_ndc;
      } else {
        this.medFormData.ndcnumber = '';
      }

      // Dosage form -> unitType (capitalized)
      const rawDf = item.dosage_form || '';
      const dfBase = (Array.isArray(rawDf) ? rawDf[0] : rawDf).split(',')[0].trim().toLowerCase();
      this.medFormData.unitType = dfBase.charAt(0).toUpperCase() + dfBase.slice(1);

      // Route mapping
      const routeMap = {
        'oral': 'Oral',
        'sublingual': 'Sublingual',
        'intravenous': 'IV (Intravenous)',
        'subcutaneous': 'SQ (Subcutaneous)',
        'intramuscular': 'IM (Intramuscular)',
        'topical': 'TOP Topical',
        'inhalation': 'Neb/INH',
        'intranasal': 'NAS Intranasal',
        'transdermal': 'TD Transdermal',
        'rectal': 'Rectally',
        'ophthalmic': 'Optic',
        'otic': 'Otic'
      };
      const candidate = Array.isArray(item.route) && item.route.length
        ? item.route[0]
        : '';
      if (candidate) {
        const r = candidate.toLowerCase();
        for (const key in routeMap) {
          if (r.includes(key)) {
            this.medFormData.route = routeMap[key];
            this.checkMedRouteSelection(this.medFormData.route);
            break;
          }
        }
      }
      
      // Hide dropdown
      this.showMedSuggestions = false;
    },

    async verifyNDC() {
      if (!this.medFormData.ndcnumber) return;
      // Implement NDC verification if needed
      console.log('Verifying NDC:', this.medFormData.ndcnumber);
    },

    closeMed() {
      let doses = document.getElementById("dosesform" + this.patient.patient_id);
      if (doses) {
        doses.reset();
        if (!this.isMobile()) doses.style.display = "none";
      }
      if (!this.isMobile()) {
        let form = document.getElementById("mediationmodal" + this.patient.patient_id);
        if (form) form.style.display = "none";
      }
      this.resetMedForm();
      this.searchedMeds = [];
      this.searchedDiags = [];
      this.mobileSubModal = null;
    },
    closeOrder() {
      let order = document.getElementById("order__popup" + this.patient.patient_id);
      order.style.display = "none";
      let orderForm = document.getElementById("orderform" + this.patient.patient_id);
      orderForm.reset();
      // Emit close event to parent component
      this.$emit('close');
    },
    showPreloader() {
      let preloader = document.getElementById("preloader");
      preloader.style.display = "block";
    },
    stopPreloader() {
      let preloader = document.getElementById("preloader");
      preloader.style.display = "none";
    },
    showMed(id) {
      let entry = document.getElementById(`med${id}`);
      if (entry) {
        entry.classList.toggle("active");
      }
    },
    showProc(index) {
      let entry = document.getElementById(`proc${index}`);
      entry.classList.toggle("active");
    },
    showDiag(index) {
      let entry = document.getElementById(`diag${index}`);
      entry.classList.toggle("active");
    },
  },
};
</script>

<style scoped lang="scss">
/* @import "/keyon"; */
@import url("https://fonts.googleapis.com/css2?family=Cedarville+Cursive&family=Satisfy&display=swap");
.satisfy-regular {
  font-family: "Satisfy", "Cedarville Cursive", cursive;
  font-weight: 400;
  font-style: normal;
  font-size: 22px;
}
.list {
  padding: 0;
}

.list__item {
  list-style-type: none;
  /*padding-bottom: 5px;*/
}

/* pagination */
.btn-number {
  border: none;
  background-color: transparent;
  cursor: pointer;
  font-size: 0.75em;
}

.pagination-controls {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 12px;
}

.pagination-page-input {
  width: 42px;
  height: 34px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  text-align: center;
}

.pagination-total {
  font-size: 0.9rem;
  color: #475569;
}

.btn-prev,
.btn-next {
  min-width: 86px;
  height: 34px;
  border: 1px solid #cbd5e1;
  border-radius: 6px;
  background-color: #ffffff;
  color: #1f2937;
  font-weight: 600;
  line-height: 1;
  padding: 0 12px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.15s ease, border-color 0.15s ease, color 0.15s ease;

  &:hover {
    background-color: #f8fafc;
    border-color: #94a3b8;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #f8fafc;
  }
}

.btn-go {
  height: 34px;
  min-width: 56px;
  border: 1px solid #0ea5e9;
  border-radius: 6px;
  background: #0ea5e9;
  color: #fff;
  font-weight: 600;
  padding: 0 12px;
  line-height: 1;
  transition: background-color 0.15s ease, border-color 0.15s ease;

  &:hover {
    background: #0284c7;
    border-color: #0284c7;
  }
}

.list__link {
  font-size: 0.9em;
  color: #0f172a !important;
  cursor: pointer;
  padding: 8px 12px;
  display: block;
  border-bottom: 1px solid #eee;
  line-height: 1.35;
  text-decoration: none;

  &:hover {
    background: #e6f4f4;
    color: #0f172a !important;
  }
}

.selected {
  background: #0060ff;
  color: white !important;
  border-radius: 3px;
}

.allergytext {
  color: red;
}

.ql-editor {
  font-size: 150%;
}
.sig-wrapper {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}
.nursig-wrapper {
  display: flex;
  width: 100%;
  justify-content: left;
}
#nursename {
  margin-right: 15px;
  font-family: "Satisfy", sans-serif;
  font-size: 25px;
}
.gvspace{
  margin-top:20px;
}
.msorderwrapper{
  position:absolute;
  /* Border only — keep keyon lightgray surface / radius; do not use .eh-popup-panel
     (that class also forces white background). */
  border: var(--eh-popup-border, 3px solid #000000);
  box-shadow: none;
}
#provname {
  font-family: "Satisfy", sans-serif;
  font-size: 25px;
  font-weight: 600;
}
.pastProvdisplay-true{
  width: 94%;
    height: 24px;
    float: left;
    margin-left: 10px;
}
.sig-wrapper input[type="text"] {
  border-top-style: none;
  border-left-style: none;
  border-right-style: none;
  margin-left: 20px;
  width: 220px;
  background-color: #d3d3d3;
}
.sig-wrapper input[type="date"] {
  width: 220px;
  background-color: #d3d3d3;
  margin-left: 15px;
}
.provsig-wrapper {
  display: flex;
  margin-top: 20px;
}
.nrssigdate {
  margin-left: 15px;
  margin-top: 10px;
}

.form-container {
  background: #fff;
  padding: 20px;
  border-radius: 8px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 500px;
}

@media only screen and (max-width: 576px) {
  .form-container {
    text-align: left;
  }
  .diagnosismodal {
    height: unset;
  }
  .icd10listcontainer {
    height: 200px;
  }
}

h2 {
  margin-top: 0;
}

.allergies {
  color: red;
}

.form-group {
  margin-bottom: 15px;
}

.form-group label {
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
}

.form-group input,
.form-group select,
.form-group :deep(.diagnosis-combobox-input) {
  width: 100%;
  padding: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

.primary-physician-chooser {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0.85rem 0.9rem 1rem;
  background: #f8fafc;
}

.primary-physician-chooser-heading {
  display: block;
  font-weight: 700;
  margin-bottom: 0.35rem;
}

.primary-physician-chooser-hint {
  margin: 0 0 0.85rem;
  font-size: 0.85rem;
  font-weight: 400;
  color: #64748b;
  line-height: 1.35;
}

.primary-physician-chooser-title {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.92rem;
  font-weight: 600;
}

.primary-physician-chooser-or {
  text-align: center;
  margin: 0.75rem 0;
  font-size: 0.85rem;
  font-weight: 700;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.primary-physician-lookup {
  position: relative;
}

.primary-physician-details {
  margin: -0.35rem 0 1rem;
}

.primary-physician-details-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding: 0.65rem 0.9rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #f8fafc;
  color: #0f766e;
  font-size: 0.92rem;
  font-weight: 600;
  cursor: pointer;
  text-align: left;

  &:hover {
    background: #f1f5f9;
  }
}

.primary-physician-details-chevron {
  font-size: 0.85rem;
  line-height: 1;
}

.primary-physician-details-panel {
  margin-top: 0.65rem;
  padding: 0.85rem 0.9rem 0.35rem;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  background: #fff;
}

.mobile-npi-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 20;
  max-height: 180px;
  overflow-y: auto;
  border: 1px solid #ccc;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
}

.form-group input[type="checkbox"],
.form-group input[type="radio"] {
  width: auto;
}

.form-actions {
  display: flex;
  justify-content: space-between;
}

.order-med-tabs {
  display: flex;
  margin-bottom: 1rem;
  border-bottom: 1px solid #ccc;
  background-color: unset;
}
.order-med-tab-btn {
  flex: 1;
  text-align: center;
  background: none;
  border: none;
  padding: 0.75rem;
  cursor: pointer;
  font-weight: 500;
  transition: background-color 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
}
.order-med-tab-btn:hover {
  background-color: #f2f2f2;
}
.order-med-tab-btn.active {
  background-color: #e6f4f4;
  border-bottom: 3px solid #0c8687;
}
.order-med-tab-label {
  font-weight: 500;
}
.order-med-tab-required {
  font-size: 0.75rem;
  color: #666;
  font-style: italic;
}

.save-btn,
.cancel-btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  width: 48%;
}

.save-btn {
  background-color: #007bff;
  color: white;
}

.cancel-btn {
  background-color: #6c757d;
  color: white;
}

.tab-container {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  margin-bottom: 15px;
}

.tab-button {
  background: #000;
  color: #fff;
  border: none;
  padding: 10px;
  cursor: pointer;
  flex-grow: 1;
  text-align: center;
}

.tab-button:hover {
  background: #333;
}

.add-medication {
  background: #000;
  color: #fff;
  border: none;
  padding: 10px;
  width: 100%;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 15px;
}

.add-medication:hover {
  background: #333;
}

.Mobile-button-group {
  display: flex;
  justify-content: space-between;
  padding-top: 10px;
}

.Mobile-button {
  flex: 1;
  margin: 0 5px;
  padding: 10px;
  border: none;
  border-radius: 5px;
  color: white;
  font-size: 1em;
  cursor: pointer;
}

.Mobile-cancel {
  background-color: #007bff;
}

.Mobile-save {
  background-color: #28a745;
}

.Mobile-add {
  background-color: black;
  width: 100%;
  margin: unset;
}

.added-items-banner {
  margin: 12px 0 8px;
  padding: 8px 12px;
  background-color: #98bfe1;
  color: #fff;
  font-weight: 700;
  font-size: 0.95rem;
  border-radius: 4px;
  text-align: center;
}

.Mobile-proc {
  height: 28% !important;
}

.accordion-content {
  display: none; /* Hide content initially */
  background-color: #f4f4f4; /* Light grey background for content */
  padding: 15px;
}

#mobile-checkbox {
  display: unset;
  margin-left: 5%;
}

.mobile-checkbox-row {
  flex-direction: row !important;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem 1.25rem;
}

.mobile-inline-checkbox {
  display: inline-flex !important;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
  margin-bottom: 0 !important;
  font-weight: 500;
  white-space: nowrap;
}

.mobile-inline-checkbox input[type="checkbox"] {
  width: auto !important;
  margin: 0;
  flex-shrink: 0;
}

.lookup-field {
  position: relative;
}

.lookup-results,
#medsearchresult.lookup-results,
#procsearchresult.lookup-results,
#diagsearchresult.lookup-results,
.medDiagSearch.lookup-results {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 1000;
  max-height: 220px;
  overflow-y: auto;
  margin: 0;
  padding: 0;
  background: #fff !important;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.12);
  text-align: start;
  width: 100%;
  height: auto;
}

/* Diagnosis add form: keep results in-flow so modal overflow:hidden does not clip them */
.diag-lookup-list {
  position: relative !important;
  top: auto !important;
  left: auto !important;
  right: auto !important;
  width: 100%;
  max-height: 220px;
  height: auto !important;
  margin-top: 0.5rem;
  overflow-y: auto;
  background: #fff;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.08);
}

.lookup-result-item {
  padding: 8px 12px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
  background: #fff;
  text-transform: none;
}

.lookup-result-item:last-child {
  border-bottom: none;
}

.lookup-result-item:nth-child(even) {
  background: #f8fafc;
}

.lookup-result-item:hover {
  background: #e6f4f4;
}

.lookup-result-title {
  display: block;
  font-size: 0.92rem;
  font-weight: 600;
  color: #0f172a;
  line-height: 1.35;
  text-transform: none;
}

.lookup-result-code {
  display: block;
  margin-top: 2px;
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 400;
}

.divider {
  color: white;
  background-color: #98bfe1;
}

.new-or-edit-grid {
  margin-bottom: 5%;
}

.medLabelGroup {
  justify-content: center;
}

.durationDays {
  align-content: end;
  margin-left: 2%;
}

/* New Medication Form Styles - Matching AddMedicationForm.vue exactly */
.new-med-form {
  padding: 1rem;
  /* Allow parent .mediationmodal flex layout to shrink this form and scroll */
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;
}

/* Pharmacy tab lives in MedicationPharmacyTabPanel.vue; scoped rules here do not apply inside the child without :deep */
.new-med-form :deep(.medication-pharmacy-panel) {
  width: 100%;
  min-width: 0;
  flex: 1 1 auto;
}

.section-title {
  font-weight: bold;
  margin: 1rem 0;
  font-size: 1.1rem;
  border-bottom: 2px solid #0c8687;
  color: #333;
  padding-bottom: 0.5rem;
}

/* Form layout */
.form-group {
  margin-bottom: 1rem;
  display: flex;
  flex-direction: column;
}
.form-group label {
  font-weight: 500;
  margin-bottom: 0.3rem;
}
.required,
span.required,
label .required,
.primary-physician-chooser-heading .required,
.vaccnt-asterik {
  color: #dc2626 !important;
}
.error-message {
  display: block;
  color: #dc3545;
  font-size: 0.875rem;
  margin-top: 0.25rem;
}
.form-group input,
.form-group select,
.form-group :deep(.diagnosis-combobox-input) {
  padding: 0.4rem 0.6rem;
  border: 1px solid #ccc;
  border-radius: 4px;
}
.checkbox-group {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}
/* Horizontal row of fields */
.form-row {
  display: flex;
  gap: 1rem;
}
.form-row .form-group {
  flex: 1;
}
.time-input-row {
  margin-bottom: 0.5rem;
}
.time-input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}
.change-reason{
  width:75%;
}
/* Bottom action buttons */
.form-actions {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  margin-top: 1rem;
}
.btn-cancel,
.btn-save,
.btn-back {
  padding: 0.6rem 1.2rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}
.btn-cancel {
  background-color: #6c757d;
  color: #fff;
}
.btn-cancel:hover {
  background-color: #5a6268;
}
.btn-save, .btn-back {
  background-color: #0c8687;
  color: #fff;
}
.btn-save:hover, .btn-back:hover {
  background-color: #0a7273;
}
/* Modal Overlay & Container */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0,0,0,0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  text-align: center;
  font-family: "Open-Sans", sans-serif;
}
.modal-content {
  background-color: #fff;
  width: 80%;
  max-width: 50%;
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 10px 25px rgba(0,0,0,0.3);
  max-height: 80%;
  overflow: scroll;
}
.mod-title{
  background-color:teal;
  color:#ffffff;
  width:100%;
  padding:10px;
}
.mod-panel{
  margin:15px;
}
.account-error{
  font-family:sans-serif;
}
.action-button-sendrequest{
  background-color:#ffffff;
  color:teal;
  font-weight:900;
  margin-right:10px;
  border-radius:3px;
  padding:10px;
}
.action-button-cancelrequest{
  color: #f00;;
  background-color:#ffffff;
  font-weight:900;
  border-radius:3px;
  padding:10px;
}
.modal-content .account-modal{
  padding:0px;
}

/* Chris additions */
.dosage-group {
  display: flex;
  flex-direction: column;
  max-width: 20%;
}
.dosage-row {
  display: flex; gap: 0.5rem; align-items: center;
}
.dosage-input {
flex: 0 0 80px; }
.dosage-select { flex: 1; }

.volume-rate-row { display: flex; gap: 1rem; }
.volume-group { display: flex; flex-direction: column; }
.volume-row {
  display: flex; gap: 0.5rem; align-items: center;
}
.volume-dropdown { width: 70px; }

.btn-save:disabled, .btn-back:disabled {
  background-color: #b2d8d8;
  cursor: not-allowed;
}

.camera-btn {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0.2rem;
  display: flex;
  align-items: center;
  transition: background 0.2s;
}
.camera-btn:hover {
  background: #e6f4f4;
  border-radius: 4px;
}

.verify-btn {
  background: #0c8687;
  color: white;
  border: none;
  border-radius: 4px;
  padding: 0.3rem 0.9rem;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.2s;
}
.verify-btn:disabled {
  background: #b2d8d8;
  cursor: not-allowed;
}
.verify-btn:hover:not(:disabled) {
  background: #0a7273;
}

.autocomplete {
  position: relative;
}
.autocomplete-input {
  width: 100%;
}
.autocomplete-input[readonly] {
  background-color: #f5f5f5;
  color: #666;
  cursor: not-allowed;
}
.suggestions-list {
  position: absolute;
  top: 100%;
  left: 0; right: 0;
  background: #fff;
  border: 1px solid #ccc;
  border-top: none;
  max-height: 200px;
  overflow-y: auto;
  z-index: 1000;
  margin: 0; padding: 0;
  list-style: none;
}
.suggestion-item {
  padding: 8px;
  cursor: pointer;
  border-bottom: 1px solid #eee;
}
.suggestion-item:last-child {
  border-bottom: none;
}
.suggestion-item:hover {
  background: #f5f5f5;
}
.suggestion-item strong {
  display: block;
}
.suggestion-item small {
  color: #666;
  font-size: 0.85em;
  display: block;
}
.suggestion-header {
  display: flex;
  align-items: baseline;
  gap: 6px;
}
.suggestion-ingredients {
  font-size: 0.85em;
  color: #555;
}
.suggestion-ndc {
  font-size: 0.85em;
  color: #777;
  margin-top: 2px;
}

/* Administration times */
.admin-times {
  margin-top: 1rem;
}

.admin-times-disclaimer {
  font-size: 0.85em;
  color: #666;
  margin-top: -5px;
  margin-bottom: 10px;
}

/* Form actions buttons - matching AddMedicationForm */
.form-actions input[type="submit"],
.form-actions input[type="button"] {
  padding: 0.6rem 1.2rem;
  border-radius: 4px;
  border: none;
  cursor: pointer;
  font-weight: 500;
}

.form-actions input[type="submit"] {
  background-color: #0c8687;
  color: #fff;
}

.form-actions input[type="submit"]:hover {
  background-color: #0a7273;
}

.form-actions input[type="button"] {
  background-color: #6c757d;
  color: #fff;
}

.form-actions input[type="button"]:hover {
  background-color: #5a6268;
}

/* Diagnosis search dropdown styling - matching AddMedicationForm */
.selectdisplay-true {
  width: 100%;
  height: 220px;
  overflow-y: scroll;
  color: black;
  display: flex;
  flex-direction: column;
  border-style: solid;
  border-width: 1px;
  border-color: #6c757d;
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  background-color: #fff;
}

.selectdisplay-false {
  display: none;
}

.additionalnameli:nth-child(even) {
  background-color: #f9f4f4;
}

.additionalnameli {
  background-color: #ffffff;
  padding: 8px 12px;
  cursor: pointer;
}

.additionalnameli:hover {
  background-color: #98bfe1;
  color: #ffffff;
}

.additionalnameli.current {
  background-color: #98bfe1;
}

/* Mobile order sub-modals (med / diag / proc add forms) */
.mobile-order-submodal-overlay {
  position: fixed;
  inset: 0;
  z-index: 10050;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(15, 23, 42, 0.55);
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);
}

.mobile-order-submodal {
  width: 100%;
  max-width: 480px;
  max-height: min(90vh, 720px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border: 5px solid black;
  border-radius: 12px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
}

.mobile-order-submodal-header {
  flex-shrink: 0;
  padding: 16px 16px 10px;
  border-bottom: 1px solid #e2e8f0;

  h2 {
    margin: 0;
    font-size: 1.15rem;
    color: #0f766e;
  }

  .allergies {
    margin: 6px 0 0;
    font-size: 0.9rem;
  }
}

.mobile-order-submodal-form {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.mobile-order-submodal-body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding: 12px 16px;
  -webkit-overflow-scrolling: touch;

  :deep(.diagnosis-combobox-list) {
    position: static;
    max-height: none;
    box-shadow: none;
    border-radius: 0 0 4px 4px;
    margin-top: 4px;
  }
}

.mobile-order-submodal-footer {
  flex-shrink: 0;
  display: flex;
  gap: 12px;
  padding: 12px 16px;
  border-top: 1px solid #e2e8f0;
  background: #fff;

  .save-btn,
  .cancel-btn {
    flex: 1;
    width: auto;
    margin: 0;
  }
}
</style>
